import React, { useState, useEffect, useRef } from 'react';
import {
  Select,
  MenuItem,
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Modal,
  InputLabel,
  Box,
  List,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import GoogleMapsAutoComplete from '../components/GoogleMapsAutoComplete';
import { useSelector, useDispatch } from "react-redux";
import AlertDialog from '../components/AlertDialog';
import { makeStyles } from '@mui/styles';
import UsersCombo from '../components/UsersCombo';
import { api } from 'common';
import Button from "components/CustomButtons/Button.js";
import { useTranslation } from "react-i18next";
import {colors} from '../components/Theme/WebTheme';
import { BookingModalBody, ContainerYardFilteredSelector, logisticsInstructionDefaults, validateBookingObj, getContainerSizeFromCarType, labelText, containerTypeOptions, sanitizeInstructionDataForVehicle, isDriverEligibleForBookingCar, shipmentTypeOptions, domesticShipmentTypeOptions, normalizeDomesticBookingInfo, normalizeImportBookingInfo, normalizeExportBookingInfo, normalizeServiceType, normalizePickupDeliveryInfo, shouldShowPickupDeliveryInfo, getAvailableServiceTypeOptions, getBookingWorkflowForBooking } from 'common/sharedFunctions';
import { useLocation, useNavigate } from 'react-router-dom';
import { calcEst, optionsRequired} from '../common/sharedFunctions';
import DialogActions from '@mui/material/DialogActions';
import CircularProgress from '@mui/material/CircularProgress';
import {MAIN_COLOR, SECONDORY_COLOR, FONT_FAMILY, formatCurrency} from "../common/sharedFunctions";
import { canDoAction } from "common/src/actions/userPermissions";

const useStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
    fontFamily:FONT_FAMILY
  },
  typography:{
    fontFamily:FONT_FAMILY,
  },
  modal: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width:480,
    maxWidth: 'calc(100vw - 32px)',
    maxHeight: 'calc(100vh - 48px)',
    overflowY: 'auto',
    overflowX: 'hidden',
    boxSizing: 'border-box',
    WebkitOverflowScrolling: 'touch',
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${colors.BLACK}`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    outline: 0,
  },
  container: {
    marginTop: theme.spacing(1),
    backgroundColor: MAIN_COLOR,
    alignContent: 'center',
    borderRadius: "8px",
    width: '70%',
   
  },
  container1: {
    backgroundColor: colors.LandingPage_Background,
    borderTopLeftRadius:"0px",
    borderTopRightRadius:"0px",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    padding:'30px',
    width: '100%',
    top: "19px",
    boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
  },
  title: {
    color: colors.WHITE,
    padding: '10px',
    backgroundColor:MAIN_COLOR,
    fontFamily:FONT_FAMILY,
    borderRadius:"10px",
    fontSize:18,

  },
  gridcontainer: {
    alignContent: 'center'
  },
  items: {
    margin: 0,
    width: '100%'
  },
  input: {
    fontSize: 18,
    color: colors.BLACK,
    fontFamily:FONT_FAMILY,
  },
  inputdimmed: {
    fontSize: 18,
    color: colors.CARD_LABEL,
    fontFamily:FONT_FAMILY,
  },
  carphoto: {
    height: '18px',
    marginRight: '10px'
  },
  carphotoRtl:{
    height: '16px',
    marginLeft:'10px'
  },
  buttonStyle: {
    margin: 0,
    width: '100%',
    height: 40,
    borderRadius: "30px",
    backgroundColor: MAIN_COLOR,
    color:colors.WHITE,
    fontFamily:FONT_FAMILY,
  },
  buttonStyle1:{
    backgroundColor: MAIN_COLOR,
    fontFamily:FONT_FAMILY
  },
  buttonStyle2:{
    backgroundColor: SECONDORY_COLOR,
    fontFamily:FONT_FAMILY
  },
  currentLocationButton: {
    width: '100%',
    minHeight: 56,
    padding: '0 14px',
    borderRadius: 4,
    border: `1px solid ${colors.TABLE_BORDER || 'rgba(0, 0, 0, 0.23)'}`,
    backgroundColor: colors.WHITE,
    color: colors.BLACK,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontSize: 16,
    fontFamily: FONT_FAMILY,
  },
  inputRtl: {
    "& label": {
      right: 25,
      left: "auto",
      fontFamily:FONT_FAMILY,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 18,
      fontFamily:FONT_FAMILY,
    },
    "& label.Mui-focused": {
      color: MAIN_COLOR,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: MAIN_COLOR,
      },
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
  rightRty:{
    "& legend": {
      marginRight: 30,
      fontFamily:FONT_FAMILY,
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
  textField: {
    "& label.Mui-focused": {
      color: MAIN_COLOR,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: MAIN_COLOR,
      },
    },
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
}));

const icons = {
  'paypal':require('../assets/payment-icons/paypal-logo.png').default,
  'braintree':require('../assets/payment-icons/braintree-logo.png').default,
  'stripe':require('../assets/payment-icons/stripe-logo.png').default,
  'paytm':require('../assets/payment-icons/paytm-logo.png').default,
  'payulatam':require('../assets/payment-icons/payulatam-logo.png').default,
  'flutterwave':require('../assets/payment-icons/flutterwave-logo.png').default,
  'paystack':require('../assets/payment-icons/paystack-logo.png').default,
  'securepay':require('../assets/payment-icons/securepay-logo.png').default,
  'payfast':require('../assets/payment-icons/payfast-logo.png').default,
  'liqpay':require('../assets/payment-icons/liqpay-logo.png').default,
  'culqi':require('../assets/payment-icons/culqi-logo.png').default,
  'mercadopago':require('../assets/payment-icons/mercadopago-logo.png').default,
  'squareup':require('../assets/payment-icons/squareup-logo.png').default,
  'wipay':require('../assets/payment-icons/wipay-logo.png').default,
  'test':require('../assets/payment-icons/test-logo.png').default,
  'razorpay':require('../assets/payment-icons/razorpay-logo.png').default,
  'paymongo':require('../assets/payment-icons/paymongo-logo.png').default,
  'gcash':require('../assets/payment-icons/paymongo-logo.png').default,
  'paymaya':require('../assets/payment-icons/paymongo-logo.png').default,
  'iyzico':require('../assets/payment-icons/iyzico-logo.png').default,
  'slickpay':require('../assets/payment-icons/slickpay-logo.png').default,
  'xendit':require('../assets/payment-icons/xendit-logo.png').default
}

const visibleLogisticsTextFields = [
  "containerNumber",
  "bookingNumber",
  "blNumber",
  "shippingLine",
  "pickupPort",
  "deliveryWarehouse"
];

const visibleLogisticsDateFields = [
  "freeTimeExpiry",
  "detentionDeadline",
  "demurrageDeadline"
];

const visibleImportDetentionDateFields = [
  "freeTimeExpiryDate",
  "lastFreeDay",
  "detentionStartDate"
];

const visibleImportDetentionTextFields = [
  { field: "detentionPenalty", labelKey: "detentionPenalty" },
  { field: "detentionRemarks", labelKey: "detentionRemarks", multiline: true }
];

const visibleGeneralCargoTextFields = [
  "itemDescription",
  "grossWeight",
  "numberOfPieces"
];

const visibleContainerBookingTextFields = [
  "itemDescription",
  "grossWeight",
  "numberOfPieces"
];

const visibleCargoDimensionFields = [
  "cargoLength",
  "cargoWidth",
  "cargoHeight"
];

const domesticBookingTextFields = [
  { field: "bookingNumber", labelKey: "domesticBookingNumber" },
  { field: "shipperName", labelKey: "shipperName" },
  { field: "consigneeName", labelKey: "consigneeName" },
  { field: "contactPerson", labelKey: "contactPerson" },
  { field: "contactNumber", labelKey: "contactNumber" },
  { field: "completeDeliveryAddress", labelKey: "completeDeliveryAddress", multiline: true }
];

const importBookingTextFields = [
  { field: "consigneeName", labelKey: "consigneeName" },
  { field: "containerNumber", labelKey: "containerNumber" },
  { field: "blNumber", labelKey: "blAwbNumber" },
  { field: "bookingNumber", labelKey: "bookingNumber" },
  { field: "shippingLine", labelKey: "shippingLine" },
  { field: "pickupPort", labelKey: "pickupPort" },
  { field: "deliveryAddress", labelKey: "deliveryWarehouse", multiline: true }
];

const exportBookingTextFields = [
  { field: "exporterShipperName", labelKey: "exporterShipperName" },
  { field: "portOfLoading", labelKey: "portOfLoading" },
  { field: "containerNumber", labelKey: "containerNumber" },
  { field: "blNumber", labelKey: "blAwbNumber" },
  { field: "bookingNumber", labelKey: "bookingNumber" },
  { field: "shippingLine", labelKey: "shippingLine" },
  { field: "deliveryAddress", labelKey: "deliveryWarehouse", multiline: true }
];

const exportDateFields = [
  "vesselEtd",
  "cargoCutOffDate"
];

const uniqueFields = (fields) => Array.from(new Set(fields));

const paymentProviderLabel = (provider) => {
  if (!provider) return "";
  if (provider.name === "gcash") return "GCash";
  if (provider.name === "paymaya") return "PayMaya";
  return "";
};

export default function AddBookings(props) {
  const { t, i18n  } = useTranslation();
  const isRTL = i18n.dir();
  const {
    getEstimate,
    clearEstimate,
    addBooking,
    clearBooking,
    MinutesPassed,
    GetDateString,
    GetDistance,
    settleBookingPayment,
    updateProfileWithEmail,
    checkUserExists,
    addFleetAdminClient,
    getFleetAdminWalletThreshold,
    editAddress,
    fetchWorkflowConfigurations,
    fetchCars,
    fetchAdditionalFees
  } = api;
  const dispatch = useDispatch();
  const classes = useStyles();
  const cartypes = useSelector(state => state.cartypes.cars);
  const containerYards = useSelector(state => state.containeryards.yards);
  const estimatedata = useSelector(state => state.estimatedata);
  const bookingdata = useSelector(state => state.bookingdata);
  const userdata = useSelector(state => state.usersdata);
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const canCreateBooking = canDoAction({
    role: auth.profile && auth.profile.usertype,
    moduleKey: "addBookings",
    action: "create",
    accessPermissions: settings && settings.accessPermissions,
    fallback: true
  });
  const providers = useSelector(state => state.paymentmethods.providers);
  const activeBookings = useSelector(state => state.bookinglistdata.active);
  const workflowconfigs = useSelector(state => state.workflowconfigs) || { configs: [] };
  const carlistdata = useSelector(state => state.carlistdata);
  const additionalfeesdata = useSelector(state => state.additionalfees);
  const [carType, setCarType] = useState(t('select_car'));
  const [pickupAddress, setPickupAddress] = useState(null);
  const [dropAddress, setDropAddress] = useState(null);
  const [stopAddresses, setStopAddresses] = useState([]);
  const [optionModalStatus, setOptionModalStatus] = useState(false);
  const [estimateModalStatus, setEstimateModalStatus] = useState(false);
  const [selectedCarDetails, setSelectedCarDetails] = useState(null);
  const [users, setUsers] = useState(null);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const [userCombo, setUserCombo] = useState(null);
  const [estimateRequested, setEstimateRequested] = useState(false);
  const [bookingType, setBookingType] = useState('Book Now');
  const rootRef = useRef(null);
  const reorderDraftAppliedRef = useRef(false);
  const [tempRoute, setTempRoute] = useState();
  const [drivers,setDrivers] = useState([]);
  const [fleetAdmins, setFleetAdmins] = useState([]);
  const [favoriteTranspo, setFavoriteTranspo] = useState(null);
  const [favoriteTranspoModalOpen, setFavoriteTranspoModalOpen] = useState(false);
  const [favoriteTranspoSearch, setFavoriteTranspoSearch] = useState('');
  const [stopSwitchConfirm, setStopSwitchConfirm] = useState({ open: false, nextServiceType: "" });
  const [paymentModalStatus, setPaymentModalStatus] = useState(false);
  const [walletModalStatus, setWalletModalStatus] = useState(false);
  const {state} = useLocation();
  const [selectedProvider, setSelectedProvider] = useState();
  const [selectedProviderIndex, setSelectedProviderIndex] = useState(0);
  const [roundTrip, setRoundTrip] = useState(0);
  const [tripInstructions, setTripInstructions] = useState('');
  const [loading, setLoading] = useState(false);
  const [bookingOnWait,setBookingOnWait] = useState();
  const [deliveryWithBid, setDeliveryWithBid] = useState(0);
  const [otherPerson, setOtherPerson] = useState(false);
  const [offerFare, setOfferFare] = useState('');
  const [minimumPrice, setMinimumPrice] = useState(0);
  const [savedAddresses, setSavedAddresses] = useState([]);
  const [savingFleetClient, setSavingFleetClient] = useState(false);
  const [fleetClientBookingInfo, setFleetClientBookingInfo] = useState({
    clientId: '',
    customerUid: '',
    clientAuthUid: null,
    globalClientNumber: null,
    organizationId: null,
    organizationClientRelationshipId: null,
    organizationClientNumber: null,
    loginStatus: 'NO_ACCOUNT',
    clientName: '',
    clientContact: '',
    clientEmail: '',
    clientAddress: '',
    truckingChargeToClient: ''
  });

  useEffect(() => {
    if (settings && settings.bookingFlow) {
        setDeliveryWithBid(settings.bookingFlow === "2" ? 1 : 0)
    }
  }, [settings, settings.bookingFlow])

  useEffect(() => {
    if (fetchWorkflowConfigurations) {
      dispatch(fetchWorkflowConfigurations());
    }
  }, [dispatch, fetchWorkflowConfigurations]);

  useEffect(() => {
    if (fetchCars && (!carlistdata || !carlistdata.cars)) {
      dispatch(fetchCars());
    }
  }, [dispatch, fetchCars, carlistdata && carlistdata.cars]);

  useEffect(() => {
    if (auth.profile && auth.profile.usertype === 'fleetadmin' && fetchAdditionalFees) {
      dispatch(fetchAdditionalFees());
    }
  }, [auth.profile, dispatch, fetchAdditionalFees]);



  const [instructionData,setInstructionData] = useState({
    otherPerson : "",
    otherPersonPhone: "",
    pickUpInstructions: "",
    deliveryInstructions: "",
    ...logisticsInstructionDefaults,
    parcelTypeIndex: 0,
    optionIndex: 0,
    parcelTypeSelected: null,
    optionSelected: null
  });

  const [profileData,setProfileData] = useState({
    firstName : '',
    lastName : '',
    email: ''
  });

  const [payment_mode, setPaymentMode] = useState(0);
  const [radioProps,setRadioProps] =  useState([]);

  const navigate = useNavigate();
  const label = (key, fallback) => {
    return labelText(t, key, fallback);
  };

  const isFleetAdminUser = auth.profile && auth.profile.usertype === 'fleetadmin';

  const getFleetAdminClientPermissionMessage = () =>
    label('fleet_client_permission_disabled', 'Add Client permission is disabled. Ask the Super Admin to enable Users / Add for Fleet Admin.');

  const canFleetAdminAddClient = () => canDoAction({
    role: auth.profile && auth.profile.usertype,
    moduleKey: "users",
    action: "add",
    accessPermissions: settings && settings.accessPermissions,
    fallback: !isFleetAdminUser
  });

  const showBookingSelectionAlert = (msg) => {
    setCommonAlert({ open: true, msg });
    if (rootRef.current && typeof rootRef.current.scrollIntoView === "function") {
      rootRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const getBookingSelectionValidationMessage = () => {
    if (!userCombo) return label('select_booking_customer_required', 'Please select a customer/client before booking.');
    if (!pickupAddress || !pickupAddress.coords) return label('select_pickup_address_required', 'Please select a valid pickup address.');
    if (!dropAddress || !dropAddress.coords) return label('select_delivery_address_required', 'Please select a valid delivery address.');
    if (!selectedCarDetails) return label('select_vehicle_type_required', 'Please select a vehicle type.');
    if (bookingType === 'Book Later' && !selectedDate) return label('select_booking_datetime_required', 'Please select booking date and time.');
    return label('complete_booking_required_fields', 'Please complete the required booking fields.');
  };

  const parseCurrencyAmount = (value) => {
    const amount = parseFloat(value);
    return isNaN(amount) ? 0 : amount;
  };

  const roundCurrencyAmount = (value) => {
    const decimal = settings && settings.decimal !== undefined ? settings.decimal : 2;
    return parseFloat(parseCurrencyAmount(value).toFixed(decimal));
  };

  const getFleetAdminCommissionConfig = () => {
    const commissionType = (selectedCarDetails && (selectedCarDetails.convenience_fee_type || selectedCarDetails.commission_type || selectedCarDetails.commissionType)) || "percentage";
    const commissionValue = selectedCarDetails && selectedCarDetails.convenience_fees !== undefined
      ? selectedCarDetails.convenience_fees
      : selectedCarDetails && selectedCarDetails.commission_rate !== undefined
        ? selectedCarDetails.commission_rate
        : selectedCarDetails && selectedCarDetails.commissionRate !== undefined
          ? selectedCarDetails.commissionRate
          : 0;
    return {
      type: commissionType,
      value: parseCurrencyAmount(commissionValue)
    };
  };

  const getFleetAdminFinancials = () => {
    const truckingChargeToClient = parseCurrencyAmount(fleetClientBookingInfo.truckingChargeToClient);
    const commissionConfig = getFleetAdminCommissionConfig();
    const superAdminCommissionAmount = commissionConfig.type === "flat"
      ? commissionConfig.value
      : truckingChargeToClient * commissionConfig.value / 100;
    const activeAdditionalFees = additionalfeesdata && Array.isArray(additionalfeesdata.fees)
      ? additionalfeesdata.fees.filter((fee) => fee && fee.active !== false)
      : [];
    const additionalFees = activeAdditionalFees.map((fee) => {
      const rateType = fee.rateType || "flat";
      const value = parseCurrencyAmount(fee.amount);
      const amount = rateType === "percentage" ? truckingChargeToClient * value / 100 : value;
      return {
        name: fee.name || "",
        rateType,
        value,
        amount: roundCurrencyAmount(amount)
      };
    });
    const totalAdditionalFeeAmount = additionalFees.reduce((total, fee) => total + parseCurrencyAmount(fee.amount), 0);
    const fleetAdminNetAmount = truckingChargeToClient - superAdminCommissionAmount - totalAdditionalFeeAmount;
    return {
      truckingChargeToClient: roundCurrencyAmount(truckingChargeToClient),
      superAdminCommissionType: commissionConfig.type,
      superAdminCommissionValue: roundCurrencyAmount(commissionConfig.value),
      superAdminCommissionAmount: roundCurrencyAmount(superAdminCommissionAmount),
      additionalFees,
      totalAdditionalFeeAmount: roundCurrencyAmount(totalAdditionalFeeAmount),
      fleetAdminNetAmount: roundCurrencyAmount(fleetAdminNetAmount)
    };
  };

  const fleetAdminFinancials = getFleetAdminFinancials();

  const hasThresholdSettingValue = (value) => value !== undefined && value !== null && value !== '';

  const getFleetAdminWalletBalance = () => {
    if (auth.profile && hasThresholdSettingValue(auth.profile.walletBalance)) {
      return parseCurrencyAmount(auth.profile.walletBalance);
    }
    const fleetAdminUid = auth.profile && auth.profile.uid;
    const fleetAdminUser = fleetAdminUid && userdata && Array.isArray(userdata.users)
      ? userdata.users.find((user) => user && (user.uid === fleetAdminUid || user.id === fleetAdminUid))
      : null;
    return parseCurrencyAmount(fleetAdminUser && fleetAdminUser.walletBalance);
  };

  const getFleetAdminWalletThresholdReferences = () => {
    const type = settings && hasThresholdSettingValue(settings.fleetAdminWalletThresholdType)
      ? settings.fleetAdminWalletThresholdType
      : (settings && settings.driverWalletThresholdType ? settings.driverWalletThresholdType : 'percentage');
    const defaultValue = type === 'percentage' ? 20 : 0;
    const value = settings && hasThresholdSettingValue(settings.fleetAdminWalletThresholdValue)
      ? settings.fleetAdminWalletThresholdValue
      : (settings && hasThresholdSettingValue(settings.driverWalletThresholdValue)
        ? settings.driverWalletThresholdValue
        : defaultValue);
    const minimumFlatRate = settings && hasThresholdSettingValue(settings.fleetAdminWalletMinimumFlatRate)
      ? settings.fleetAdminWalletMinimumFlatRate
      : (settings && settings.driverWalletMinimumFlatRate);
    return {
      fleetAdminWalletThresholdType: type,
      fleetAdminWalletThresholdValue: roundCurrencyAmount(value),
      fleetAdminWalletMinimumFlatRate: roundCurrencyAmount(minimumFlatRate)
    };
  };

  const handleFleetClientBookingInfoChange = (event) => {
    const { name, value } = event.target;
    setFleetClientBookingInfo({
      ...fleetClientBookingInfo,
      [name]: value
    });
  };

  const getFleetClientAddress = (client) => {
    if (!client) return '';
    if (client.clientAddress) return client.clientAddress;
    if (client.address) return client.address;
    const saved = normalizeSavedAddresses(client.savedAddresses);
    const firstAddress = saved.length > 0 ? saved[0] : null;
    return firstAddress ? (firstAddress.description || firstAddress.add || firstAddress.address || '') : '';
  };

  const handleFleetClientSelection = (event, client) => {
    setUserCombo(client);
    if (!client) {
      setFleetClientBookingInfo({
        ...fleetClientBookingInfo,
        clientId: '',
        customerUid: '',
        clientAuthUid: null,
        globalClientNumber: null,
        organizationId: null,
        organizationClientRelationshipId: null,
        organizationClientNumber: null,
        loginStatus: 'NO_ACCOUNT',
        clientName: '',
        clientContact: '',
        clientEmail: '',
        clientAddress: ''
      });
      return;
    }
    const clientName = client.clientName || `${client.firstName || ''} ${client.lastName || ''}`.trim();
    setFleetClientBookingInfo({
      ...fleetClientBookingInfo,
      clientId: client.organizationClientRelationshipId || client.relationshipId || client.uid || client.id || '',
      customerUid: client.clientAuthUid || (client.loginStatus === 'LINKED' ? (client.uid || client.id || '') : ''),
      clientAuthUid: client.clientAuthUid || null,
      globalClientNumber: client.globalClientNumber || null,
      organizationId: client.organizationId || null,
      organizationClientRelationshipId: client.organizationClientRelationshipId || client.relationshipId || client.uid || client.id || '',
      organizationClientNumber: client.organizationClientNumber || null,
      loginStatus: client.loginStatus || (client.clientAuthUid ? 'LINKED' : 'NO_ACCOUNT'),
      clientName,
      clientContact: client.clientContact || client.mobile || '',
      clientEmail: client.clientEmail || client.email || '',
      clientAddress: getFleetClientAddress(client)
    });
  };

  const handleCreateFleetClient = async () => {
    if (isFleetAdminUser && !canFleetAdminAddClient()) {
      setCommonAlert({ open: true, msg: getFleetAdminClientPermissionMessage() });
      return;
    }
    if (!fleetClientBookingInfo.clientName.trim() || !fleetClientBookingInfo.clientContact.trim()) {
      setCommonAlert({ open: true, msg: label('client_name_contact_required', 'Client name and contact are required.') });
      return;
    }
    setSavingFleetClient(true);
    try {
      const createdClient = await dispatch(addFleetAdminClient({
        clientName: fleetClientBookingInfo.clientName,
        clientContact: fleetClientBookingInfo.clientContact,
        clientEmail: fleetClientBookingInfo.clientEmail,
        clientAddress: fleetClientBookingInfo.clientAddress
      }));
      const comboClient = {
        ...createdClient,
        desc: `${createdClient.clientName || `${createdClient.firstName || ''} ${createdClient.lastName || ''}`.trim()} (${createdClient.clientContact || createdClient.mobile || ''}) ${createdClient.clientEmail || createdClient.email || ''}`.trim(),
        savedAddresses: createdClient.savedAddresses || null,
        pushToken: createdClient.pushToken || ''
      };
      setUsers((currentUsers) => {
        const current = currentUsers || [];
        const existingIndex = current.findIndex((client) => (client.uid || client.id) === createdClient.id);
        if (existingIndex === -1) return [...current, comboClient];
        return current.map((client, index) => index === existingIndex ? comboClient : client);
      });
      setUserCombo(comboClient);
      setFleetClientBookingInfo({
        ...fleetClientBookingInfo,
        clientId: createdClient.organizationClientRelationshipId || createdClient.id,
        customerUid: createdClient.clientAuthUid || '',
        clientAuthUid: createdClient.clientAuthUid || null,
        globalClientNumber: createdClient.globalClientNumber || null,
        organizationId: createdClient.organizationId || null,
        organizationClientRelationshipId: createdClient.organizationClientRelationshipId || createdClient.id,
        organizationClientNumber: createdClient.organizationClientNumber || null,
        loginStatus: createdClient.loginStatus || (createdClient.clientAuthUid ? 'LINKED' : 'NO_ACCOUNT'),
        clientName: createdClient.clientName || `${createdClient.firstName || ''} ${createdClient.lastName || ''}`.trim(),
        clientContact: createdClient.clientContact || createdClient.mobile || '',
        clientEmail: createdClient.clientEmail || createdClient.email || '',
        clientAddress: getFleetClientAddress(createdClient)
      });
      setCommonAlert({
        open: true,
        msg: createdClient.reusedExisting
          ? label('fleet_client_reused', 'Existing customer found, linked, and selected successfully.')
          : label('fleet_client_created', 'Client created and selected successfully.')
      });
    } catch (error) {
      setCommonAlert({ open: true, msg: error && error.message ? error.message : label('fleet_client_create_failed', 'Unable to create client.') });
    } finally {
      setSavingFleetClient(false);
    }
  };

  const normalizeSavedAddresses = (addresses) => {
    if (!addresses) return [];
    if (Array.isArray(addresses)) {
      return addresses.map((address, index) => ({ ...address, id: address.id || index.toString() }));
    }
    return Object.keys(addresses).map((key) => ({ ...addresses[key], id: key }));
  };

  useEffect(() => {
    const source = userCombo && userCombo.savedAddresses ? userCombo.savedAddresses : (auth.profile && auth.profile.savedAddresses ? auth.profile.savedAddresses : null);
    setSavedAddresses(normalizeSavedAddresses(source));
  }, [userCombo, auth.profile]);

  const applyAddressFor = (target, address) => {
    if (!address) return;
    const lat = address.lat !== undefined ? address.lat : (address.coords ? address.coords.lat : null);
    const lng = address.lng !== undefined ? address.lng : (address.coords ? address.coords.lng : null);
    if (lat === null || lng === null) {
      setCommonAlert({ open: true, msg: t('place_to_coords_error') });
      return;
    }
    const nextAddress = {
      description: address.description || address.add || address.name || `${lat}, ${lng}`,
      coords: { lat: parseFloat(lat), lng: parseFloat(lng) },
      source: address.source || 'savedAddress'
    };
    if (target === 'pickup') {
      setPickupAddress(nextAddress);
    } else {
      setDropAddress(nextAddress);
    }
  };

  const applySavedAddressFor = (target, id) => {
    const address = savedAddresses.find((item) => item.id === id);
    applyAddressFor(target, address);
  };

  const saveAddressFor = (target) => {
    const address = target === 'pickup' ? pickupAddress : dropAddress;
    const uid = userCombo && userCombo.uid ? userCombo.uid : (auth.profile && auth.profile.uid ? auth.profile.uid : null);
    if (!uid || !address || !address.coords) {
      setCommonAlert({ open: true, msg: label('select_address_before_save', 'Please select a customer/client and a valid address before saving this address.') });
      return;
    }
    const defaultName = target === 'pickup' ? label('pickup_location', 'Pickup Location') : label('drop_location', 'Delivery Address');
    const name = window.prompt(label('save_address_name', 'Saved Address Name'), defaultName);
    if (!name) return;
    const savedAddress = {
      name,
      description: address.description,
      lat: address.coords.lat,
      lng: address.coords.lng,
      count: 1
    };
    dispatch(editAddress(uid, savedAddress, 'Add'));
    setSavedAddresses([...savedAddresses, { ...savedAddress, id: `local-${Date.now()}` }]);
  };

  const applyCurrentLocationFor = (target) => {
    if (!navigator.geolocation) {
      setCommonAlert({ open: true, msg: label('location_not_supported', 'Location is not supported on this device.') });
      return;
    }

    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        const fallbackAddress = `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
        const applyLocation = (description) => {
          applyAddressFor(target, { description, lat, lng, source: 'currentLocation' });
          setLoading(false);
        };

        if (window.google && window.google.maps && window.google.maps.Geocoder) {
          const geocoder = new window.google.maps.Geocoder();
          let finished = false;
          const finishLocation = (description) => {
            if (finished) return;
            finished = true;
            applyLocation(description);
          };
          const timer = setTimeout(() => finishLocation(fallbackAddress), 3500);
          geocoder.geocode({ location: { lat, lng } }, (results, status) => {
            clearTimeout(timer);
            if (status === 'OK' && results && results[0]) {
              finishLocation(results[0].formatted_address);
            } else {
              finishLocation(fallbackAddress);
            }
          });
        } else {
          applyLocation(fallbackAddress);
        }
      },
      () => {
        setLoading(false);
        setCommonAlert({ open: true, msg: t('location_permission_error') });
      },
      { enableHighAccuracy: false, timeout: 15000, maximumAge: 60000 }
    );
  };

  const isPickupDeliverySelected = normalizeServiceType(instructionData.serviceType) === 'pickup_delivery';
  const hasAddedStops = stopAddresses.some((stop) => !!stop);
  const validStopWaypoints = isPickupDeliverySelected
    ? stopAddresses.filter((stop) => stop && stop.coords && Number.isFinite(parseFloat(stop.coords.lat)) && Number.isFinite(parseFloat(stop.coords.lng))).map((stop) => ({
        lat: parseFloat(stop.coords.lat),
        lng: parseFloat(stop.coords.lng),
        add: stop.description || stop.add || "",
        source: stop.source || 'search'
      }))
    : [];
  const stopWaypointsStr = validStopWaypoints.map((stop) => `${stop.lat},${stop.lng}`).join('|');
  const buildDropAddressForBooking = () => {
    if (!dropAddress) return dropAddress;
    if (!isPickupDeliverySelected || validStopWaypoints.length === 0) {
      return { ...dropAddress, waypoints: null, waypointsStr: null };
    }
    return {
      ...dropAddress,
      waypoints: validStopWaypoints,
      waypointsStr: stopWaypointsStr
    };
  };
  const clearAddedStops = () => {
    setStopAddresses([]);
  };
  const addStopAddress = () => {
    setStopAddresses((prev) => [...prev, null]);
  };
  const updateStopAddress = (index, value) => {
    setStopAddresses((prev) => prev.map((stop, stopIndex) => stopIndex === index ? value : stop));
  };
  const removeStopAddress = (index) => {
    setStopAddresses((prev) => prev.filter((_, stopIndex) => stopIndex !== index));
  };
  const getStopValidationMessage = () => {
    if (!isPickupDeliverySelected || stopAddresses.length === 0) return "";
    return stopAddresses.some((stop) => !stop || !stop.coords)
      ? label('select_stop_address', 'Please select or remove each added stop address.')
      : "";
  };
  const continueServiceSwitchAfterClearingStops = () => {
    const nextServiceType = stopSwitchConfirm.nextServiceType || 'logistics_shipment';
    clearAddedStops();
    setInstructionData((prev) => ({
      ...prev,
      serviceType: nextServiceType,
      shipmentType: nextServiceType === 'pickup_delivery' ? "" : prev.shipmentType
    }));
    setStopSwitchConfirm({ open: false, nextServiceType: "" });
  };

  const getFavoriteTranspoName = (company) => {
    if (!company) return "";
    const personName = `${company.firstName || ""} ${company.lastName || ""}`.trim();
    return company.companyName || company.businessName || company.fleetAdminName || personName || "Logistics Company";
  };

  const getFavoriteTranspoType = (company) => {
    return company && company.companyType ? company.companyType : "Logistics Company";
  };

  const getFavoriteTranspoCoverage = (company) => {
    if (!company) return "";
    if (Array.isArray(company.vehicleCoverage)) return company.vehicleCoverage.filter(Boolean).join(", ");
    return company.vehicleCoverage || company.carType || company.vehicleType || "";
  };

  const isActiveFleetAdminCompany = (user) => {
    return !!(user && user.usertype === "fleetadmin" && user.approved === true && user.active !== false);
  };

  const setPreferredTranspo = (company) => {
    const companyId = company ? (company.id || company.uid) : "";
    const companyName = getFavoriteTranspoName(company);
    setFavoriteTranspo(company);
    setFavoriteTranspoModalOpen(false);
    setFavoriteTranspoSearch("");
    setInstructionData((prev) => ({
      ...prev,
      favoriteTranspoType: company ? "fleetadmin" : "",
      favoriteTranspoId: companyId,
      favoriteTranspoName: company ? companyName : "",
      preferredFleetAdminId: companyId,
      preferredFleetAdminName: company ? companyName : "",
      favoriteTranspoDriver: "",
      favoriteTranspoDriverName: "",
      favoriteTranspoDriverCarType: "",
      favoriteTranspoFleetAdmin: "",
      favoriteDriver: "",
      favoriteDriverName: "",
      favoriteDriverType: "",
      preferredDriverId: "",
      preferredDriverName: "",
      requestedDrivers: {}
    }));
  };

  const clearPreferredTranspo = () => {
    setPreferredTranspo(null);
  };

  const withoutPreferenceFields = (data) => ({
    ...data,
    favoriteTranspoType: "",
    favoriteTranspoId: "",
    favoriteTranspoName: "",
    favoriteTranspoFleetAdmin: "",
    preferredFleetAdminId: "",
    preferredFleetAdminName: "",
    favoriteDriver: "",
    favoriteDriverName: "",
    favoriteDriverType: "",
    preferredDriverId: "",
    preferredDriverName: "",
    requestedDrivers: {},
    favoriteTranspoDriver: "",
    favoriteTranspoDriverName: "",
    favoriteTranspoDriverCarType: ""
  });

  const cleanWebsiteBookingPreferenceFields = (bookingObject) => {
    if (!bookingObject) {
      return bookingObject;
    }
    const instruction = { ...(bookingObject.instructionData || {}) };
    const fleetPreferenceId = instruction.preferredFleetAdminId || instruction.favoriteTranspoId || bookingObject.preferredFleetAdminId || bookingObject.favoriteTranspoId || "";
    const fleetPreferenceName = instruction.preferredFleetAdminName || instruction.favoriteTranspoName || bookingObject.preferredFleetAdminName || bookingObject.favoriteTranspoName || "";
    [
      "favoriteTranspoCompanyName",
      "favoriteTranspoFleetAdmin",
      "favoriteDriver",
      "favoriteDriverName",
      "favoriteDriverType",
      "requestedDrivers",
      "favoriteTranspoDriver",
      "favoriteTranspoDriverName",
      "favoriteTranspoDriverCarType",
      "preferredDriverId",
      "preferredDriverName"
    ].forEach((field) => {
      delete instruction[field];
    });
    if (fleetPreferenceId) {
      instruction.favoriteTranspoType = "fleetadmin";
      instruction.favoriteTranspoId = fleetPreferenceId;
      instruction.favoriteTranspoName = fleetPreferenceName;
      instruction.preferredFleetAdminId = fleetPreferenceId;
      instruction.preferredFleetAdminName = fleetPreferenceName;
    } else {
      [
        "favoriteTranspoType",
        "favoriteTranspoId",
        "favoriteTranspoName",
        "preferredFleetAdminId",
        "preferredFleetAdminName"
      ].forEach((field) => {
        delete instruction[field];
      });
    }
    const cleanedBooking = { ...bookingObject };
    if (bookingObject.instructionData) {
      cleanedBooking.instructionData = instruction;
    }
    delete cleanedBooking.preRequestedDrivers;
    delete cleanedBooking.requestedDrivers;
    delete cleanedBooking.driverEstimates;
    [
      "favoriteTranspoCompanyName",
      "favoriteTranspoFleetAdmin",
      "favoriteDriver",
      "favoriteDriverName",
      "favoriteDriverType",
      "favoriteTranspoDriver",
      "favoriteTranspoDriverName",
      "favoriteTranspoDriverCarType",
      "preferredDriverId",
      "preferredDriverName"
    ].forEach((field) => {
      delete cleanedBooking[field];
    });
    if (fleetPreferenceId) {
      cleanedBooking.favoriteTranspoType = "fleetadmin";
      cleanedBooking.favoriteTranspoId = fleetPreferenceId;
      cleanedBooking.favoriteTranspoName = fleetPreferenceName;
      cleanedBooking.preferredFleetAdminId = fleetPreferenceId;
      cleanedBooking.preferredFleetAdminName = fleetPreferenceName;
    } else {
      [
        "favoriteTranspoType",
        "favoriteTranspoId",
        "favoriteTranspoName",
        "preferredFleetAdminId",
        "preferredFleetAdminName"
      ].forEach((field) => {
        delete cleanedBooking[field];
      });
    }
    return cleanedBooking;
  };

  const clearPreferredTransportOption = () => {
    setFavoriteTranspo(null);
    setFavoriteTranspoSearch("");
    setFavoriteTranspoModalOpen(false);
    setInstructionData((prev) => withoutPreferenceFields(prev));
  };

  useEffect(()=>{
      if(settings && providers){
        setSelectedProvider(providers[0]);
        let arr = [{ label: t('wallet'), value: 0, cat: 'wallet' }];
        let val = 0;
        if(!settings.disable_online && providers && providers.length > 0){
            val++;
            arr.push({ label: t('card'), value: val , cat: 'card' });
        }
        if(!settings.disable_cash){
            val++;
            arr.push({ label: t('cash'), value: val, cat: 'cash' });
        }
        setRadioProps(arr);
      }
  },[settings, providers, t]);;

  useEffect(() => {
    if(state && state !== null && state.carData){
      let carDetails = state.carData;
      const carInstructionData = sanitizeInstructionDataForVehicle(logisticsInstructionDefaults, carDetails, workflowconfigs.configs || []);
      setCarType(carDetails.name)
      setInstructionData({
        deliveryPerson : "",
        deliveryPersonPhone: "",
        pickUpInstructions: "",
        deliveryInstructions: "",
        ...carInstructionData,
        containerSize: getContainerSizeFromCarType(carDetails),
        parcelTypeIndex: 0,
        optionIndex: 0,
        parcelTypeSelected: Array.isArray(carDetails.parcelTypes) ? carDetails.parcelTypes[0] : null,
        optionSelected: Array.isArray(carDetails.options) ? carDetails.options[0] : null
      })
      setSelectedCarDetails(carDetails);
    }
  }, [state, workflowconfigs.configs]);

  useEffect(() => {
    const reorderDraft = state && state.reorderDraft ? state.reorderDraft : null;
    if (!reorderDraft || reorderDraftAppliedRef.current || !cartypes) {
      return;
    }

    reorderDraftAppliedRef.current = true;
    const draftCarType = reorderDraft.carType || "";
    const carDetails = cartypes.find((car) => car.name === draftCarType) || null;
    const draftInstructionData = reorderDraft.instructionData || {};
    let nextInstructionData = {
      ...logisticsInstructionDefaults,
      ...draftInstructionData
    };

    if (carDetails) {
      nextInstructionData = sanitizeInstructionDataForVehicle(nextInstructionData, carDetails, workflowconfigs.configs || []);
      nextInstructionData.containerSize = getContainerSizeFromCarType(carDetails);
      if (Array.isArray(carDetails.parcelTypes)) {
        nextInstructionData.parcelTypeIndex = 0;
        nextInstructionData.parcelTypeSelected = carDetails.parcelTypes[0];
      }
      if (Array.isArray(carDetails.options)) {
        nextInstructionData.optionIndex = 0;
        nextInstructionData.optionSelected = carDetails.options[0];
      }
      setCarType(carDetails.name);
      setSelectedCarDetails(carDetails);
    } else {
      setCarType(draftCarType || t('select_car'));
      setSelectedCarDetails(null);
    }

    setInstructionData({
      otherPerson: "",
      otherPersonPhone: "",
      pickUpInstructions: "",
      deliveryInstructions: "",
      parcelTypeIndex: 0,
      optionIndex: 0,
      parcelTypeSelected: null,
      optionSelected: null,
      ...nextInstructionData
    });

    if (reorderDraft.pickupAddress && reorderDraft.pickupAddress.coords) {
      setPickupAddress(reorderDraft.pickupAddress);
    }
    if (reorderDraft.dropAddress && reorderDraft.dropAddress.coords) {
      setDropAddress(reorderDraft.dropAddress);
      if (Array.isArray(reorderDraft.dropAddress.waypoints)) {
        setStopAddresses(reorderDraft.dropAddress.waypoints.map((point) => ({
          description: point.add || point.description || "",
          add: point.add || point.description || "",
          coords: {
            lat: parseFloat(point.lat),
            lng: parseFloat(point.lng)
          },
          source: point.source || "reorder"
        })).filter((point) => Number.isFinite(point.coords.lat) && Number.isFinite(point.coords.lng)));
      }
    }

    if (auth.profile && auth.profile.usertype !== "customer" && reorderDraft.customer && reorderDraft.customer.uid) {
      const existingUser = Array.isArray(users) ? users.find((user) => user.uid === reorderDraft.customer.uid) : null;
      setUserCombo(existingUser || reorderDraft.customer);
    }
  }, [state, cartypes, users, workflowconfigs.configs, auth.profile, t]);

  const handleChange = (e) => {
    if(e.target.name === 'parcelTypeIndex'){
      setInstructionData({ 
        ...instructionData,
        parcelTypeIndex: parseInt(e.target.value),
        parcelTypeSelected: selectedCarDetails.parcelTypes[e.target.value]
      });
    }else if(e.target.name === 'optionIndex'){
      setInstructionData({ 
        ...instructionData,
        optionIndex: parseInt(e.target.value),
        optionSelected: selectedCarDetails.options[e.target.value]
      });
    }else if(e.target.name === 'payment_mode'){
      setPaymentMode(e.target.value);
    }else if(e.target.name === 'selectedProviderIndex'){
      setSelectedProviderIndex(parseInt(e.target.value));
      setSelectedProvider(providers[parseInt(e.target.value)]);
    }else if(e.target.name === 'tripInstructions'){
      setTripInstructions(e.target.value);
    }else if(e.target.name === 'roundTrip'){
      setRoundTrip(e.target.value);
    }else if(e.target.name === 'bookingFlow'){
      setDeliveryWithBid(e.target.value);
    }else if(e.target.name === 'firstName'){
      setProfileData({ ...profileData, [e.target.name]: e.target.value });
    }else if(e.target.name === 'lastName'){
      setProfileData({ ...profileData, [e.target.name]: e.target.value });
    }else if(e.target.name === 'email'){
      setProfileData({ ...profileData, [e.target.name]: e.target.value });
    }else if(e.target.name === 'offerFare'){
      setOfferFare(e.target.value);
    }else if(e.target.name === 'serviceType'){
      const value = normalizeServiceType(e.target.value);
      if (value !== 'pickup_delivery' && hasAddedStops) {
        setStopSwitchConfirm({ open: true, nextServiceType: value });
        return;
      }
      setInstructionData({
        ...instructionData,
        serviceType: value,
        shipmentType: value === 'pickup_delivery' ? "" : instructionData.shipmentType
      });
    }else if(e.target.name === 'emptyReturnContainerYardIds'){
      const selectedIds = e.target.value;
      const selectedYards = containerYards ? containerYards.filter((item) => selectedIds.indexOf(item.id) !== -1) : [];
      setInstructionData({
        ...instructionData,
        emptyReturnContainerYardIds: selectedIds,
        emptyReturnContainerYardId: selectedIds.length > 0 ? selectedIds[0] : "",
        emptyReturnContainerYardName: selectedYards.map((yard) => yard.name).join(", "),
        emptyReturnContainerYardSlots: selectedYards.map((yard) => yard.availableSlots || 0).join(", ")
      });
    }else if(e.target.name === 'pickupContainerYardId' || e.target.name === 'emptyReturnContainerYardId'){
      const yard = containerYards ? containerYards.find((item) => item.id === e.target.value) : null;
      const prefix = e.target.name === 'pickupContainerYardId' ? 'pickupContainerYard' : 'emptyReturnContainerYard';
      setInstructionData({
        ...instructionData,
        [e.target.name]: e.target.value,
        [`${prefix}Name`]: yard ? yard.name : "",
        [`${prefix}Slots`]: yard ? yard.availableSlots : ""
      });
    }else{
      const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
      setInstructionData({ ...instructionData, [e.target.name]: value });
    }
  };

  const additionalContainerNumbers = Array.isArray(instructionData.additionalContainerNumbers) ? instructionData.additionalContainerNumbers : [];
  const updateAdditionalContainerNumber = (index, value) => {
    const next = [...additionalContainerNumbers];
    next[index] = value;
    setInstructionData({ ...instructionData, additionalContainerNumbers: next });
  };
  const setDomesticBookingInfoField = (field, value) => {
    setInstructionData({
      ...instructionData,
      domesticBookingInfo: {
        ...domesticBookingInfo,
        [field]: value
      }
    });
  };
  const setImportBookingInfoField = (field, value) => {
    setInstructionData({
      ...instructionData,
      importBookingInfo: {
        ...importBookingInfo,
        [field]: value
      }
    });
  };
  const setExportBookingInfoField = (field, value) => {
    setInstructionData({
      ...instructionData,
      exportBookingInfo: {
        ...exportBookingInfo,
        [field]: value
      }
    });
  };
  const setPickupDeliveryInfoField = (field, value) => {
    setInstructionData({
      ...instructionData,
      pickupDeliveryInfo: {
        ...pickupDeliveryInfo,
        [field]: value
      }
    });
  };

  const addEligibleDriverRequests = (requestedDrivers, driverEstimates = {}) => {
    const selectedContainerSize = getContainerSizeFromCarType(selectedCarDetails);
    if (!drivers || !selectedCarDetails) {
      return { requestedDrivers, driverEstimates };
    }
    drivers.forEach((driver) => {
      if (!driver || !driver.uid || !isDriverEligibleForBookingCar(driver.carType, selectedCarDetails)) {
        return;
      }
      if (auth.profile.usertype === 'fleetadmin' && driver.fleetadmin !== auth.profile.uid) {
        return;
      }
      let distance = 0;
      if (pickupAddress && pickupAddress.coords && driver.location) {
        distance = GetDistance(pickupAddress.coords.lat, pickupAddress.coords.lng, driver.location.lat, driver.location.lng);
        if (settings.convert_to_mile) {
          distance = distance / 1.609344;
        }
      }
      if (!selectedContainerSize && settings.autoDispatch && distance >= ((settings && settings.driverRadius) ? settings.driverRadius : 10)) {
        return;
      }
      requestedDrivers[driver.uid] = true;
      driverEstimates[driver.uid] = { distance, timein_text: distance ? ((distance * 2) + 1).toFixed(0) + ' min' : '' };
    });
    return { requestedDrivers, driverEstimates };
  };

  const [selectedDate, setSelectedDate] = useState(GetDateString());

  const clearForm = () => {
    setUserCombo(null);
    setPickupAddress(null);
    setDropAddress(null);
    clearAddedStops();
    setSelectedCarDetails(null);
    setCarType(t('select_car'));
    setBookingType('Book Now');
    setEstimateRequested(false);
    setFavoriteTranspo(null);
    setFavoriteTranspoSearch("");
    setFavoriteTranspoModalOpen(false);
    setFleetClientBookingInfo({
      clientId: '',
      clientName: '',
      clientContact: '',
      clientEmail: '',
      clientAddress: '',
      truckingChargeToClient: ''
    });
    setInstructionData({
      otherPerson : "",
      otherPersonPhone: "",
      pickUpInstructions: "",
      deliveryInstructions: "",
      ...logisticsInstructionDefaults,
      parcelTypeIndex: 0,
      optionIndex: 0,
      parcelTypeSelected: null,
      optionSelected: null
    });
  }

  useEffect(() => {
    if (auth.profile && bookingOnWait) {
      setEstimateModalStatus(false); 
      dispatch(addBooking(bookingOnWait));
      setBookingOnWait(null);
      setLoading(false);
    }
  }, [auth.profile,bookingOnWait,dispatch,addBooking])

  useEffect(() => {
    if (bookingdata.booking && bookingdata.booking.mainData.status === 'PAYMENT_PENDING') {
      if(bookingdata.booking.mainData.payment_mode === 'cash'){
        dispatch(clearBooking());
        setTempRoute(null);
        navigate('/bookings')
      } else{
        if(bookingdata.booking.mainData.payment_mode === 'card'){
          setPaymentModalStatus(true);
        }else{
          setWalletModalStatus(true);
        }
      }
    }
    if (bookingdata.booking && bookingdata.booking.mainData.status === 'NEW') {
      dispatch(clearBooking());
      setTempRoute(null);
      navigate('/bookings')
    }
  }, [bookingdata.booking,clearBooking,dispatch,navigate]);

  const handleCarSelect = (event) => {
    setCarType(event.target.value);
    clearPreferredTransportOption();
    let carDetails = null;
    for (let i = 0; i < cartypes.length; i++) {
      if (cartypes[i].name === event.target.value) {
        carDetails = cartypes[i];
        let instObj = withoutPreferenceFields({ ...instructionData });
        if(Array.isArray(cartypes[i].parcelTypes)){
          instObj.parcelTypeSelected = cartypes[i].parcelTypes[0];
          instObj.parcelTypeIndex = 0;
        }
        if(Array.isArray(cartypes[i].options)){
          instObj.optionSelected = cartypes[i].options[0];
          instObj.optionIndex = 0;
        }
        instObj = sanitizeInstructionDataForVehicle(instObj, cartypes[i], workflowconfigs.configs || []);
        instObj.containerSize = getContainerSizeFromCarType(cartypes[i]);
        setInstructionData(instObj);
      }
    }
    if (!carDetails) {
      setInstructionData(withoutPreferenceFields({ ...instructionData, containerSize: "" }));
    }
    setSelectedCarDetails(carDetails);
  };

  const handleBookTypeSelect = (event) => {
    setBookingType(event.target.value);
    if (bookingType === 'Book Later') {
      setSelectedDate(GetDateString());
    }
  };

  const onDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  useEffect(() => {
    if (estimatedata.estimate && estimateRequested) {
      setEstimateRequested(false);
      setEstimateModalStatus(true);
    }
    if (estimatedata.estimate && estimateRequested && settings && !settings.coustomerBidPrice) {
      let  price = estimatedata.estimate.estimateFare;
      let ammount =  settings.coustomerBidPriceType === 'flat' ? parseFloat(price- settings.bidprice).toFixed(settings.decimal) : parseFloat(price - parseFloat(price*(settings.bidprice/100))).toFixed(settings.decimal);
      if(ammount && ammount > 0){setMinimumPrice(ammount)}
    }
    if (userdata.users) {
      let arr = [];
      for (let i = 0; i < userdata.users.length; i++) {
        let user = userdata.users[i];
        const fleetadmins = user.fleetadmins;
        const isLinkedFleetClient = Array.isArray(fleetadmins)
          ? fleetadmins.some((uid) => `${uid}` === `${auth.profile.uid}`)
          : fleetadmins && typeof fleetadmins === 'object'
            ? !!fleetadmins[auth.profile.uid]
            : fleetadmins
              ? `${fleetadmins}` === `${auth.profile.uid}`
              : false;
        const isOwnedFleetClient = user.fleetadmin === auth.profile.uid || user.createdBy === auth.profile.uid || isLinkedFleetClient;
        if (user.usertype === 'customer' && user.active !== false && ((auth.profile.usertype === 'fleetadmin' && isOwnedFleetClient) || auth.profile.usertype === 'admin')) {
          const clientName = user.clientName || `${user.firstName || ''} ${user.lastName || ''}`.trim();
          arr.push({
            'firstName': user.firstName,
            'lastName': user.lastName,
            'mobile': user.mobile,
            'email': user.email,
            'uid': user.id,
            'id': user.id,
            'clientName': clientName,
            'clientContact': user.clientContact || user.mobile || '',
            'clientEmail': user.clientEmail || user.email || '',
            'clientAddress': user.clientAddress || user.address || '',
            'fleetadmin': user.fleetadmin || null,
            'createdBy': user.createdBy || null,
            'fleetadmins': user.fleetadmins || null,
            'savedAddresses': user.savedAddresses ? user.savedAddresses : null,
            'desc': clientName + ' (' + (settings.AllowCriticalEditsAdmin? (user.clientContact || user.mobile || '') : t("hidden_demo")) + ') ' + (settings.AllowCriticalEditsAdmin? (user.clientEmail || user.email || '') : t("hidden_demo")),
            'pushToken': user.pushToken ? user.pushToken : ''
          });
        }
      }
      setUsers(arr);
      let arrDrivers = [];
      let arrFleetAdmins = [];
      for (let i = 0; i < userdata.users.length; i++) {
        let user = userdata.users[i];
        if (isActiveFleetAdminCompany(user)) {
          arrFleetAdmins.push({
            'uid': user.id,
            'id': user.id,
            'firstName': user.firstName || '',
            'lastName': user.lastName || '',
            'mobile': user.mobile || '',
            'email': user.email || '',
            'companyName': user.companyName || '',
            'businessName': user.businessName || '',
            'fleetAdminName': user.fleetAdminName || '',
            'companyType': user.companyType || '',
            'vehicleCoverage': user.vehicleCoverage || user.carType || user.vehicleType || ''
          });
        }
        if ((user.usertype) && (user.usertype === 'driver') && (user.approved === true) && (user.queue === false) && (user.driverActiveStatus === true) && (user.location) && ((user.licenseImage && settings.license_image_required) || !settings.license_image_required) && ((user.carApproved && settings.carType_required) || !settings.carType_required) && ((user.term && settings.term_required) || !settings.term_required)) {
          if((auth.profile.usertype === 'fleetadmin' && user.fleetadmin === auth.profile.uid) || auth.profile.usertype === 'admin' || auth.profile.usertype === 'customer'){
            arrDrivers.push({
              'uid': user.id,
              'firstName': user.firstName || '',
              'lastName': user.lastName || '',
              'mobile': user.mobile || '',
              'email': user.email || '',
              'location': user.location,
              'carType': user.carType,
              'fleetadmin': user.fleetadmin ? user.fleetadmin : null
            });
          }
        }
      }
      setDrivers(arrDrivers);
      setFleetAdmins(arrFleetAdmins);
    }
  }, [estimatedata.estimate, userdata.users, estimateRequested, settings, auth.profile.usertype, auth.profile.uid,t]);
 
 
  useEffect(() => {
    if(auth.profile.usertype && auth.profile.usertype==='customer'){
      setUserCombo({
        'firstName': auth.profile.firstName,
        'lastName': auth.profile.lastName,
        'mobile': auth.profile.mobile,
        'email': auth.profile.email,
        'uid': auth.profile.uid,
        'savedAddresses': auth.profile.savedAddresses ? auth.profile.savedAddresses : null,
        'pushToken': auth.profile.pushToken ? auth.profile.pushToken : ''
      })
    }
  }, [auth.profile]);


  const mobile = (userCombo && userCombo.mobile ? true : false);
  const selectedCarContainerSize = getContainerSizeFromCarType(selectedCarDetails);
  const showContainerInfo = selectedCarContainerSize === "20ft" || selectedCarContainerSize === "40ft";
  const selectedCarBookingInfo = !!selectedCarDetails;
  const availableServiceTypes = hasAddedStops ? ["pickup_delivery"] : getAvailableServiceTypeOptions(selectedCarDetails, instructionData);
  const pickupDeliveryInfo = normalizePickupDeliveryInfo(instructionData);
  const showPickupDeliveryInfo = selectedCarBookingInfo && shouldShowPickupDeliveryInfo(instructionData, selectedCarDetails);
  const bookingWorkflow = getBookingWorkflowForBooking(instructionData, selectedCarDetails, workflowconfigs.configs || []);
  const showPrimaryInfo = selectedCarBookingInfo && bookingWorkflow.showPrimaryForm;
  const showShipmentTypeSelector = selectedCarBookingInfo && bookingWorkflow.showShipmentTypeSelector;
  const showDomesticShipmentSelector = false;
  const domesticBookingInfo = normalizeDomesticBookingInfo(instructionData);
  const importBookingInfo = normalizeImportBookingInfo(instructionData, selectedCarDetails);
  const exportBookingInfo = normalizeExportBookingInfo(instructionData, selectedCarDetails);
  const showDomesticInfo = selectedCarBookingInfo && bookingWorkflow.showDomesticForm;
  const showImportInfo = selectedCarBookingInfo && bookingWorkflow.showImportForm;
  const showExportInfo = selectedCarBookingInfo && bookingWorkflow.showExportForm;
  const normalizePreferenceVehicleType = (value) => {
    const raw = typeof value === "string" ? value : (value && (value.name || value.carType || value.vehicleType || value.vehicleTypeName || value.carTypeName)) || "";
    const normalized = `${raw}`.toLowerCase().trim().replace(/[^a-z0-9]/g, "");
    if (!normalized) return "";
    if (/(20)(ft|footer|foot)/.test(normalized) || normalized.indexOf("20footer") >= 0 || normalized.indexOf("20ft") >= 0) return "20ft";
    if (/(40)(ft|footer|foot)/.test(normalized) || normalized.indexOf("40footer") >= 0 || normalized.indexOf("40ft") >= 0) return "40ft";
    if (/(10)(ft|footer|foot)/.test(normalized) || normalized.indexOf("10footer") >= 0 || normalized.indexOf("10ft") >= 0) return "10ft";
    if (normalized.indexOf("l300") >= 0 || normalized.indexOf("fbvan") >= 0 || normalized.indexOf("vanaluminum") >= 0) return "l300fbvan";
    if (normalized.indexOf("truck3tons") >= 0 || normalized.indexOf("3tons") >= 0 || normalized.indexOf("3ton") >= 0) return "truck3tons";
    if (normalized.indexOf("sedan") >= 0 || normalized === "car") return "carsedan";
    if (normalized.indexOf("motorcycle") >= 0 || normalized.indexOf("motor") >= 0) return "motorcycle";
    return normalized;
  };

  const getUserIdentityValues = (user) => {
    if (!user) return [];
    return [
      user.id,
      user.uid,
      user.name,
      user.fullName,
      `${user.firstName || ""} ${user.lastName || ""}`.trim()
    ].filter(Boolean).map(value => `${value}`.toLowerCase().trim());
  };

  const fieldMatchesUser = (fieldValue, user) => {
    const identities = getUserIdentityValues(user);
    if (!fieldValue || identities.length === 0) return false;
    if (Array.isArray(fieldValue)) {
      return fieldValue.some(value => fieldMatchesUser(value, user));
    }
    if (typeof fieldValue === "object") {
      return Object.keys(fieldValue).some(key => fieldValue[key] && identities.indexOf(`${key}`.toLowerCase().trim()) >= 0);
    }
    return identities.indexOf(`${fieldValue}`.toLowerCase().trim()) >= 0;
  };

  const isTruthyOrMissing = (value) => {
    return value === undefined || value === null || value === "" || value === true || value === "true" || value === 1 || value === "1";
  };

  const isPreferenceCarUsable = (car) => {
    return !!(car && isTruthyOrMissing(car.active) && isTruthyOrMissing(car.approved) && isTruthyOrMissing(car.carApproved));
  };

  const getPreferenceCarVehicleKey = (car) => {
    return normalizePreferenceVehicleType(car && (car.carType || car.vehicleType || car.vehicleTypeName || car.carTypeName || car.name || car.cartype || car.type));
  };

  const hasSelectedPreferenceVehicle = !!selectedCarDetails && carType !== t('select_car');
  const selectedPreferenceVehicleKey = hasSelectedPreferenceVehicle ? normalizePreferenceVehicleType(selectedCarDetails || carType) : "";
  const selectedPreferenceVehicleMessage = 'Please select vehicle type first.';
  const preferenceCars = Array.isArray(carlistdata && carlistdata.cars) ? carlistdata.cars : [];

  const hasMatchingFleetCar = (company) => {
    if (!selectedPreferenceVehicleKey) return false;
    return preferenceCars.some(car => (
      isPreferenceCarUsable(car) &&
      fieldMatchesUser(car.fleetadmin || car.fleetAdmin || car.fleetadminId || car.fleetAdminId || car.createdBy, company) &&
      getPreferenceCarVehicleKey(car) === selectedPreferenceVehicleKey
    ));
  };

  const filteredFavoriteTranspos = (fleetAdmins || []).filter((company) => {
    if (!selectedPreferenceVehicleKey || !hasMatchingFleetCar(company)) return false;
    const search = favoriteTranspoSearch.toLowerCase();
    const searchable = `${getFavoriteTranspoName(company)} ${getFavoriteTranspoType(company)} ${getFavoriteTranspoCoverage(company)}`.toLowerCase();
    return !search || searchable.indexOf(search) !== -1;
  });

  useEffect(() => {
    if (favoriteTranspo && !hasMatchingFleetCar(favoriteTranspo)) {
      clearPreferredTranspo();
    }
  }, [selectedPreferenceVehicleKey, carlistdata && carlistdata.cars]);

  useEffect(() => {
    if (!showPickupDeliveryInfo) {
      return;
    }
    const nextPickupAddress = pickupAddress ? (pickupAddress.description || pickupAddress.add || "") : "";
    const nextDeliveryAddress = dropAddress ? (dropAddress.description || dropAddress.add || "") : "";
    if (
      nextPickupAddress !== (pickupDeliveryInfo.pickupAddress || "") ||
      nextDeliveryAddress !== (pickupDeliveryInfo.deliveryAddress || "")
    ) {
      setInstructionData((prev) => ({
        ...prev,
        pickupDeliveryInfo: {
          ...normalizePickupDeliveryInfo(prev),
          pickupAddress: nextPickupAddress,
          deliveryAddress: nextDeliveryAddress
        }
      }));
    }
  }, [showPickupDeliveryInfo, pickupAddress, dropAddress, pickupDeliveryInfo]);

  const handleGetOptions = (e) => {
    e.preventDefault();
    if (!canCreateBooking) {
      setCommonAlert({ open: true, msg: label('action_permission_denied', 'You do not have permission to create bookings. Please contact your administrator.') });
      return;
    }
    if(auth.profile.usertype === 'customer' || auth.profile.usertype==='admin' || auth.profile.usertype === 'fleetadmin'){
      if(!(settings && settings.disable_cash && (auth.profile.usertype==='admin'|| auth.profile.usertype === 'fleetadmin')) || auth.profile.usertype==='customer'){
        if((auth.profile.usertype==='customer' && parseFloat(auth.profile.walletBalance)>=0) || auth.profile.usertype==='admin' || auth.profile.usertype === 'fleetadmin'){
          setEstimateRequested(true);
          if (userCombo && pickupAddress && dropAddress && selectedCarDetails) {
            const stopError = getStopValidationMessage();
            if (stopError) {
              setCommonAlert({ open: true, msg: stopError });
              return;
            }
            const bookingDropAddress = buildDropAddressForBooking();
            if (process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true') {
              if (mobile !== true) {
                setCommonAlert({ open: true, msg: t('incomplete_user') });
                return;
              }
              const toRadians = (value) => value * Math.PI / 180;
              const lat1 = toRadians(pickupAddress.coords.lat);
              const lat2 = toRadians(dropAddress.coords.lat);
              const latDelta = toRadians(dropAddress.coords.lat - pickupAddress.coords.lat);
              const lngDelta = toRadians(dropAddress.coords.lng - pickupAddress.coords.lng);
              const haversine = Math.sin(latDelta / 2) ** 2 +
                Math.cos(lat1) * Math.cos(lat2) * Math.sin(lngDelta / 2) ** 2;
              const distanceInKm = Math.max(1, 6371 * 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine)));
              const route = {
                distance_in_km: distanceInKm,
                time_in_secs: Math.round(distanceInKm / 35 * 3600),
                polylinePoints: ''
              };
              setTempRoute(route);
              if (Array.isArray(selectedCarDetails.options) || Array.isArray(selectedCarDetails.parcelTypes)) {
                setOptionModalStatus(true);
              } else {
                dispatch(getEstimate({
                  pickup: pickupAddress,
                  drop: bookingDropAddress,
                  carDetails: selectedCarDetails,
                  instructionData,
                  routeDetails: route
                }));
              }
              return;
            }
            const directionWaypoints = isPickupDeliverySelected && validStopWaypoints.length > 0
              ? validStopWaypoints.map((stop) => ({
                  location: new window.google.maps.LatLng(stop.lat, stop.lng),
                  stopover: true
                }))
              : [];
            const directionService = new window.google.maps.DirectionsService();
            directionService.route(
              {
                origin: new window.google.maps.LatLng(pickupAddress.coords.lat, pickupAddress.coords.lng),
                destination: new window.google.maps.LatLng(dropAddress.coords.lat, dropAddress.coords.lng),
                waypoints: directionWaypoints,
                optimizeWaypoints: false,
                travelMode: window.google.maps.TravelMode.DRIVING
              },
              (result, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {
                  const legs = result.routes[0].legs || [];
                  const route = {
                    distance_in_km:(legs.reduce((total, leg) => total + (leg.distance ? leg.distance.value : 0), 0) / 1000),
                    time_in_secs:legs.reduce((total, leg) => total + (leg.duration ? leg.duration.value : 0), 0),
                    polylinePoints:result.routes[0].overview_polyline
                  };
                  setTempRoute(route);
                  if(pickupAddress && dropAddress){
                    if (bookingType === 'Book Now') {
                      if(mobile === true){
                        if(Array.isArray(selectedCarDetails.options) || Array.isArray(selectedCarDetails.parcelTypes)){
                          setOptionModalStatus(true);
                        }else{
                          let estimateRequest = {
                            pickup: pickupAddress,
                            drop: bookingDropAddress,
                            carDetails: selectedCarDetails,
                            instructionData: instructionData,
                            routeDetails: route
                          };
                          dispatch(getEstimate(estimateRequest));
                        }
                      }else{
                        setCommonAlert({ open: true, msg: t('incomplete_user')});
                      }
                    } else {
                        if (bookingType === 'Book Later' && selectedDate) {
                          if (MinutesPassed(selectedDate) >= 15) {
                            if(mobile === true){
                              if(Array.isArray(selectedCarDetails.options) || Array.isArray(selectedCarDetails.parcelTypes)){
                                setOptionModalStatus(true);
                              }else{
                                let estimateRequest = {
                                  pickup: pickupAddress,
                                  drop: bookingDropAddress,
                                  carDetails: selectedCarDetails,
                                  instructionData: instructionData,
                                  routeDetails: route
                                };
                                dispatch(getEstimate(estimateRequest));
                              }
                            }else{
                              setCommonAlert({ open: true, msg: t('incomplete_user')});
                            }
                          } else {
                            setCommonAlert({ open: true, msg: t('past_booking_error') });
                          }
                        } else {
                          setCommonAlert({ open: true, msg: label('select_booking_datetime_required', 'Please select booking date and time.') });
                        }
                      }
                  } else {
                    setCommonAlert({ open: true, msg: t('place_to_coords_error') })
                  }
                }
              }
            )
          } else {
            showBookingSelectionAlert(getBookingSelectionValidationMessage());
          }
        }else{
          setCommonAlert({ open: true, msg: t('wallet_balance_low') })
        }
      } else {
        setCommonAlert({ open: true, msg: t('cash_booking_false') })
      }
    } else {
      setCommonAlert({ open: true, msg: t('verifyid_error') })
    }    
  }

  const handleWalletPayment = async (e) => {
    e.preventDefault();
    let curBooking = { ...bookingdata.booking.mainData };
    if(parseFloat(curBooking.trip_cost)>parseFloat(auth.profile.walletBalance) && radioProps[payment_mode].cat === 'wallet'){
      setCommonAlert({open:true, msg: t('wallet_balance_low')});
    }else{
      try {
        setLoading(true);
        await dispatch(settleBookingPayment(bookingdata.booking.booking_id));
        dispatch(clearEstimate());
        setPaymentModalStatus(false);
        setWalletModalStatus(false);
        clearForm();
        dispatch(clearBooking());
        setTempRoute(null);
        navigate('/bookings');
      } catch (error) {
        setCommonAlert({ open: true, msg: error && error.message ? error.message : t('payment_failed') });
      } finally {
        setLoading(false);
      }
    }
  }

  const handleGetEstimate = (e) => {
    e.preventDefault();
    setOptionModalStatus(false);
    let estimateRequest = {
      pickup: pickupAddress,
      drop: buildDropAddressForBooking(),
      carDetails: selectedCarDetails,
      instructionData: instructionData,
      routeDetails: tempRoute
    };
    dispatch(getEstimate(estimateRequest));
  };

  const confirmBooking = (e) => {
    e.preventDefault();
    if (!canCreateBooking) {
      setCommonAlert({ open: true, msg: label('action_permission_denied', 'You do not have permission to create bookings. Please contact your administrator.') });
      return;
    }
    let fleetAdminWalletThresholdData = {};
    if (isFleetAdminUser) {
      const walletBalance = getFleetAdminWalletBalance();
      const walletThresholdRequiredAmount = getFleetAdminWalletThreshold(
        settings,
        fleetAdminFinancials.truckingChargeToClient
      );
      if (walletBalance < walletThresholdRequiredAmount) {
        setCommonAlert({
          open: true,
          msg: 'Your Fleet Admin wallet balance is below the required threshold. Please top up before creating this private client booking.'
        });
        return;
      }
      fleetAdminWalletThresholdData = {
        ...getFleetAdminWalletThresholdReferences(),
        walletBalanceAtBooking: roundCurrencyAmount(walletBalance),
        walletThresholdRequiredAmount: roundCurrencyAmount(walletThresholdRequiredAmount),
        walletThresholdPassed: true
      };
    }
    let requestedDrivers = {};
    let driverEstimates = {};
    addEligibleDriverRequests(requestedDrivers, driverEstimates);

    let notfound = true;
    if(activeBookings){
        for(let i=0; i<activeBookings.length; i++){
            if(activeBookings[i].payment_mode==='wallet' && activeBookings[i].status!=='PAID'){
                notfound = false;
                break;
            }
        }
    }

    if((radioProps[payment_mode].cat === 'wallet' && notfound && auth.profile.usertype === 'customer') || radioProps[payment_mode].cat !== 'wallet' || auth.profile.usertype === 'admin' || auth.profile.usertype === 'fleetadmin'){
      const regx1 = /([0-9\s-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
      if ((otherPerson && /\S/.test(instructionData.otherPerson) && regx1.test(instructionData.otherPersonPhone) && instructionData.otherPersonPhone && instructionData.otherPersonPhone.length > 6) || !otherPerson){
        if((offerFare > 0 && offerFare >= parseFloat(minimumPrice)) || offerFare === ''){
          if ((radioProps[payment_mode].cat === 'wallet' && (parseFloat(auth.profile.walletBalance) >= parseFloat(estimatedata.estimate.estimateFare)) && !calcEst && auth.profile.usertype === 'customer') || radioProps[payment_mode].cat !== 'wallet' || (radioProps[payment_mode].cat === 'wallet' && calcEst && auth.profile.usertype === 'customer')|| auth.profile.usertype === 'admin' || auth.profile.usertype === 'fleetadmin') {
            let bookingObject = {
              pickup: pickupAddress,
              drop: buildDropAddressForBooking(),
              carDetails: selectedCarDetails,
              userDetails: {
                uid: userCombo.uid,
                firstName: userCombo.firstName,
                lastName: userCombo.lastName,
                mobile: userCombo.mobile,
                pushToken: userCombo.pushToken,
                email: userCombo.email
              },
              estimate: estimatedata.estimate,
              instructionData: instructionData,
              tripInstructions: tripInstructions,
              roundTrip: roundTrip === 0? false: true,
              tripdate: bookingType === 'Book Later' ? new Date(selectedDate).getTime() : new Date().getTime(),
              bookLater: bookingType === 'Book Later' ? true : false,
              settings: settings,
              booking_type_admin: auth.profile.usertype === 'admin'? true: false,
              booking_type_fleetadmin: auth.profile.usertype === 'fleetadmin'? true: false,
              fleetadmin: auth.profile.usertype === 'fleetadmin'? auth.profile.uid: null,
              requestedDrivers: calcEst ? requestedDrivers : (optionsRequired && radioProps[payment_mode].cat === 'cash') ? requestedDrivers : (settings.prepaid && radioProps[payment_mode].cat === 'cash') ? requestedDrivers : !settings.prepaid ? requestedDrivers : requestedDrivers ,
              driverEstimates: driverEstimates,
              payment_mode: (auth.profile.usertype === 'admin' || auth.profile.usertype === 'fleetadmin' )?'cash':radioProps[payment_mode].cat,
              booking_from_web: true,
              deliveryWithBid : auth.profile.usertype === 'customer'?  deliveryWithBid === 0 ? false : true :false,
              offerFare: (offerFare && offerFare > 0) ? offerFare : 0,
              ...(isFleetAdminUser ? {
                bookingSource: "fleet_admin_client",
                createdByRole: "fleetadmin",
                createdBy: auth.profile.uid,
                fleetadmin: auth.profile.uid,
                visibility: "private",
                deliveryWithBid: false,
                booking_type_fleetadmin: true,
                clientId: fleetClientBookingInfo.clientId || (userCombo && (userCombo.organizationClientRelationshipId || userCombo.relationshipId || userCombo.uid)) || "",
                customerUid: fleetClientBookingInfo.customerUid || fleetClientBookingInfo.clientAuthUid || "",
                clientAuthUid: fleetClientBookingInfo.clientAuthUid || null,
                globalClientNumber: fleetClientBookingInfo.globalClientNumber || null,
                organizationId: fleetClientBookingInfo.organizationId || (auth.profile && (auth.profile.organizationId || auth.profile.uid)) || null,
                organizationClientRelationshipId: fleetClientBookingInfo.organizationClientRelationshipId || fleetClientBookingInfo.clientId || "",
                organizationClientNumber: fleetClientBookingInfo.organizationClientNumber || null,
                loginStatus: fleetClientBookingInfo.loginStatus || (fleetClientBookingInfo.clientAuthUid ? 'LINKED' : 'NO_ACCOUNT'),
                clientName: (fleetClientBookingInfo.clientName || "").trim(),
                clientContact: (fleetClientBookingInfo.clientContact || "").trim(),
                clientEmail: (fleetClientBookingInfo.clientEmail || "").trim(),
                clientAddress: (fleetClientBookingInfo.clientAddress || "").trim(),
                truckingChargeToClient: fleetAdminFinancials.truckingChargeToClient,
                ...fleetAdminWalletThresholdData,
                superAdminCommissionType: fleetAdminFinancials.superAdminCommissionType,
                superAdminCommissionValue: fleetAdminFinancials.superAdminCommissionValue,
                superAdminCommissionAmount: fleetAdminFinancials.superAdminCommissionAmount,
                additionalFees: fleetAdminFinancials.additionalFees,
                totalAdditionalFeeAmount: fleetAdminFinancials.totalAdditionalFeeAmount,
                fleetAdminNetAmount: fleetAdminFinancials.fleetAdminNetAmount
              } : {})
            };
            bookingObject = cleanWebsiteBookingPreferenceFields(bookingObject);

            if(auth.profile.usertype === 'customer' && !(auth.profile.firstName && auth.profile.lastName && auth.profile.email && auth.profile.firstName.length>0 && auth.profile.lastName.length>0 && auth.profile.email.length>0)){
              // const regx1 = /([0-9\s-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
              // if ((optionsRequired && /\S/.test(instructionData.deliveryPerson) && regx1.test(instructionData.deliveryPersonPhone) && instructionData.deliveryPersonPhone && instructionData.deliveryPersonPhone.length > 6) || !optionsRequired){
                if((profileData.firstName && profileData.firstName.length > 0 && profileData.lastName && profileData.lastName.length > 0) || (auth.profile.firstName && auth.profile.firstName.length > 0 && auth.profile.lastName && auth.profile.lastName.length > 0)){
                  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                  if((re.test(profileData.email) && !auth.profile.email) || (auth.profile.email && auth.profile.email.length > 0)){
                    setLoading(true);
                    checkUserExists({email: profileData.email}).then(async(res) => {
                      if (res.users && res.users.length > 0) {
                        setLoading(false);
                        alert(t('user_exists'));
                      }
                      else if(res.error){
                        setLoading(false);
                        alert(t('email_or_mobile_issue'));
                      } else{
                        setLoading(false);
                        if(radioProps[payment_mode].cat === 'card'){
                          const paymentPacket = { 
                            payment_mode: 'card',
                            customer_paid: parseFloat(estimatedata.estimate.estimateFare).toFixed(settings.decimal),
                            cardPaymentAmount: parseFloat(estimatedata.estimate.estimateFare).toFixed(settings.decimal),
                            discount: 0,
                            usedWalletMoney:0,
                            cashPaymentAmount: 0,
                            promo_applied: false,
                            promo_details: null,
                            payableAmount: parseFloat(estimatedata.estimate.estimateFare).toFixed(settings.decimal),
                          };
                          bookingObject['paymentPacket'] = paymentPacket;
                        }
                
                        const result = validateBookingObj(t, bookingObject, instructionData, otherPerson, workflowconfigs.configs || []);
                        if(result.error){
                          setCommonAlert({ open: true, msg: result.msg });
                        } else{
                          profileData['uid'] = auth.profile.uid;
                          let bookingData = result.bookingObject;
                          bookingData.userDetails.firstName = profileData.firstName;
                          bookingData.userDetails.lastName = profileData.lastName;
                          bookingData.userDetails.email = profileData.email;
                          setBookingOnWait(bookingData);
                        }
                        setTimeout(()=>{
                          dispatch(updateProfileWithEmail(profileData));
                        },200) 
                      }
                  });
                  } else {
                    setCommonAlert({ open: true, msg: t('proper_email') })
                  }
                } else {
                  setCommonAlert({ open: true, msg: t('proper_input_name') })
                }
              // } else {
              //   setCommonAlert({ open: true, msg: t('deliveryDetailMissing') })
              // }
            } else{
              if(radioProps[payment_mode].cat === 'card'){
                const paymentPacket = { 
                  payment_mode: 'card',
                  customer_paid: parseFloat(estimatedata.estimate.estimateFare).toFixed(settings.decimal),
                  cardPaymentAmount: parseFloat(estimatedata.estimate.estimateFare).toFixed(settings.decimal),
                  discount: 0,
                  usedWalletMoney:0,
                  cashPaymentAmount: 0,
                  promo_applied: false,
                  promo_details: null,
                  payableAmount: parseFloat(estimatedata.estimate.estimateFare).toFixed(settings.decimal),
                };
                bookingObject['paymentPacket'] = paymentPacket;
              }
              const result = validateBookingObj(t, bookingObject, instructionData, otherPerson, workflowconfigs.configs || []);
              if(result.error){
                setCommonAlert({ open: true, msg: result.msg });
              } else{
                setEstimateModalStatus(false); 
                dispatch(addBooking(result.bookingObject));
              }
            }
          }else{
            setCommonAlert({ open: true, msg: t('wallet_balance_low') });
          }
        }else{
          setCommonAlert({ open: true, msg: t('offer_price_greter_minimum_price') })
        }
      } else {
        setCommonAlert({ open: true, msg: t('otherPersonDetailMissing') })
      }
    } else {
      setCommonAlert({ open: true, msg: t('wallet_booking_alert') });
    }
  };

  const handleOptionModalClose = (e) => {
    e.preventDefault();
    setOptionModalStatus(false);
  };

  const handleEstimateModalClose = (e) => {
    e.preventDefault();
    setEstimateModalStatus(false);
    dispatch(clearEstimate());
    setEstimateRequested(false);
  };

  const handleEstimateErrorClose = (e) => {
    e.preventDefault();
    dispatch(clearEstimate());
    setEstimateRequested(false);
  };

  const handleBookingErrorClose = (e) => {
    e.preventDefault();
    dispatch(clearBooking());
    setEstimateRequested(false);
  };

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };

  const handleWalletModalClose = (e) => {
    setTimeout(()=>{
      setWalletModalStatus(false);
      dispatch(clearBooking());
      dispatch(clearEstimate());
    },1500);
  }

  const handlePaymentModalClose = (e) => {
    setTimeout(()=>{
      setPaymentModalStatus(false);
      dispatch(clearBooking());
      dispatch(clearEstimate());
    },1500);
  }

  const renderAddressPicker = (target) => {
    const isPickup = target === 'pickup';
    const currentAddress = isPickup ? pickupAddress : dropAddress;
    const setAddress = isPickup ? setPickupAddress : setDropAddress;
    const title = isPickup
      ? label('pickup_location', 'Pickup Location')
      : (isPickupDeliverySelected ? label('final_delivery_location', 'Final Delivery Address') : label('drop_location', 'Delivery Address'));

    return (
      <>
        <Grid item xs={12}>
          <Typography className={classes.typography} style={{ fontFamily: FONT_FAMILY, fontWeight: 600 }}>
            {title}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <button
            type="button"
            className={classes.currentLocationButton}
            onClick={(event) => {
              event.preventDefault();
              applyCurrentLocationFor(target);
            }}
          >
            {label('use_current_location', 'Use Current Location')}
          </button>
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth variant="outlined" className={isRTL==='rtl'?classes.inputRtl:classes.textField}>
            <InputLabel id={`${target}-saved-address-label`} style={{ fontFamily: FONT_FAMILY }}>{t('saved_address')}</InputLabel>
            <Select
              labelId={`${target}-saved-address-label`}
              value=""
              onChange={(event) => applySavedAddressFor(target, event.target.value)}
              label={t('saved_address')}
              style={{direction:isRTL==='rtl'?'rtl':'ltr', fontFamily: FONT_FAMILY}}
            >
              <MenuItem value=""><em>{savedAddresses.length > 0 ? t('saved_address') : t('no_saved_address')}</em></MenuItem>
              {savedAddresses.map((address) => (
                <MenuItem key={`${target}-${address.id}`} value={address.id}>
                  {(address.name || t('saved_address')) + (address.description ? ` - ${address.description}` : '')}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <GoogleMapsAutoComplete
            variant={"outlined"}
            placeholder={label('search_address', 'Search for an address')}
            value={currentAddress}
            className={classes.items}
            onChange={(value) => setAddress(value)}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            size="sm"
            onClick={(event) => {
              event.preventDefault();
              saveAddressFor(target);
            }}
            className={classes.buttonStyle1}
            style={{ width: '100%', color: colors.WHITE }}
          >
            {label('save_address', 'Save Address')}
          </Button>
        </Grid>
      </>
    );
  };

  const renderStopPicker = () => {
    if (!isPickupDeliverySelected) return null;
    return (
      <>
        <Grid item xs={12}>
          <Typography className={classes.typography} style={{ fontFamily: FONT_FAMILY, fontWeight: 600 }}>
            {label('add_stop', 'Add Stop')}
          </Typography>
        </Grid>
        {stopAddresses.map((stop, index) => (
          <Grid item xs={12} key={`stop-${index}`}>
            <Box style={{ border: `1px solid ${colors.TABLE_BORDER || '#ddd'}`, borderRadius: 6, padding: 12, backgroundColor: colors.WHITE }}>
              <Typography className={classes.typography} style={{ fontWeight: 600, marginBottom: 8 }}>
                {label('stop', 'Stop')} {index + 1}
              </Typography>
              <GoogleMapsAutoComplete
                variant={"outlined"}
                placeholder={`${label('search_address', 'Search for an address')} - ${label('stop', 'Stop')} ${index + 1}`}
                value={stop}
                className={classes.items}
                onChange={(value) => updateStopAddress(index, value)}
              />
              <button
                type="button"
                onClick={(event) => {
                  event.preventDefault();
                  removeStopAddress(index);
                }}
                style={{
                  marginTop: 10,
                  minHeight: 36,
                  padding: '0 14px',
                  borderRadius: 4,
                  border: `1px solid ${colors.RED}`,
                  color: colors.RED,
                  backgroundColor: colors.WHITE,
                  cursor: 'pointer',
                  fontFamily: FONT_FAMILY
                }}
              >
                {label('remove_stop', 'Remove Stop')}
              </button>
            </Box>
          </Grid>
        ))}
        <Grid item xs={12}>
          <button
            type="button"
            className={classes.currentLocationButton}
            onClick={(event) => {
              event.preventDefault();
              addStopAddress();
            }}
          >
            + {label('add_stop', 'Add Stop')}
          </button>
        </Grid>
      </>
    );
  };

  return (
    <div className={classes.container} ref={rootRef}>
      <Grid item xs={12} sm={12} md={8} lg={8}>
        <Grid item xs={12}>
            <Typography className={classes.title} style={{textAlign:isRTL==='rtl'?'right':'left',fontFamily:FONT_FAMILY}}>
              {t('add_booking_title')}
            </Typography>
          </Grid>
        <div className={classes.container1}>
          <Grid container spacing={2} >
            <Grid item xs={12} >
              {users && auth.profile.usertype === 'admin' ?
                <UsersCombo
                  className={classes.items}
                  placeholder={t('select_user')}
                  users={users}
                  value={userCombo}
                  onChange={(event, newValue) => {
                    setUserCombo(newValue);
                  }}
                />
                : null}
            </Grid>
            {renderAddressPicker('pickup')}
            {renderStopPicker()}
            {renderAddressPicker('drop')}
            <Grid item xs={12} sm={6} >
              {cartypes ?
                  <Select
                     labelId="demo-simple-select-label"
                     id="demo-simple-select"
                      value={carType}
                      onChange={handleCarSelect}
                      variant="outlined"
                      fullWidth
                      style={{textAlign:isRTL==='rtl'? 'right':'left',}}
                      className={carType === t('select_car') ? classes.inputdimmed : classes.input}
                      sx={{color: colors.BLACK,
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: MAIN_COLOR,
                      },}}
                     
                  >
                    <MenuItem dense={true} value={t('select_car')} key={t('select_car')} style={{direction:isRTL==='rtl'?'rtl':'ltr', width:'100%', justifyContent:'flex-start', paddingLeft:10,fontFamily:FONT_FAMILY}}>
                      {t('select_car')}
                    </MenuItem>
                    {
                      cartypes.sort((a, b) => a.pos - b.pos).map((car) =>
                        <MenuItem dense={true}  key={car.name} value={car.name} style={{direction:isRTL==='rtl'?'rtl':'ltr', width:'100%', justifyContent:'flex-start', paddingLeft:10,fontFamily:FONT_FAMILY}}>
                          <img src={car.image} className={isRTL==='rtl'? classes.carphotoRtl : classes.carphoto} alt="car types"/>{car.name}
                        </MenuItem>
                      )
                    }
                  </Select>
                : null}
            </Grid>
            <Grid item xs={12}>
              <Box style={{ border: `1px solid ${colors.TABLE_BORDER || '#ddd'}`, borderRadius: 6, padding: 12, backgroundColor: colors.WHITE }}>
                <Typography className={classes.typography} style={{ fontFamily: FONT_FAMILY, fontWeight: 600, marginBottom: 8 }}>
                  Preferred Transport Option
                </Typography>
                {!selectedPreferenceVehicleKey ?
                  <Typography className={classes.typography} style={{ color: colors.CARD_LABEL, marginBottom: 10 }}>
                    {selectedPreferenceVehicleMessage}
                  </Typography>
                : null}
                {favoriteTranspo ?
                  <Box>
                    <Typography className={classes.typography} style={{ fontWeight: 600 }}>{getFavoriteTranspoName(favoriteTranspo)}</Typography>
                    <Typography className={classes.typography} style={{ color: colors.CARD_LABEL }}>Logistics Company</Typography>
                    <Box style={{ display: 'flex', gap: 10, marginTop: 12 }}>
                      <Button size="sm" color="secondaryButton" onClick={() => setFavoriteTranspoModalOpen(true)}>Change</Button>
                      <Button size="sm" color="secondaryButton" onClick={clearPreferredTranspo}>Clear</Button>
                    </Box>
                  </Box>
                :
                  <Box style={{ display: 'flex', flexDirection: 'column', gap: 6, maxWidth: 360 }}>
                    <Button
                      size="sm"
                      color="secondaryButton"
                      disabled={!selectedPreferenceVehicleKey}
                      onClick={() => selectedPreferenceVehicleKey ? setFavoriteTranspoModalOpen(true) : setCommonAlert({ open: true, msg: selectedPreferenceVehicleMessage })}
                      style={{ width: '100%', justifyContent: 'center' }}
                    >
                      Logistics Company
                    </Button>
                    <Typography className={classes.typography} style={{ color: colors.CARD_LABEL }}>Optional</Typography>
                  </Box>
                }
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
                <Select
                  id="booking-type-native"
                  value={bookingType}
                  onChange={handleBookTypeSelect}
                  className={classes.input}
                  style={{textAlign:isRTL==='rtl'? 'right':'left'}}
                  sx={{color: colors.BLACK,
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: MAIN_COLOR,
                      },}}
                  variant="outlined"
                  fullWidth
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem dense key={"Book Now"} value={"Book Now"} style={{direction:isRTL==='rtl'?'rtl':'ltr', width:'100%', justifyContent:'flex-start', paddingLeft:10,fontFamily:FONT_FAMILY}}>
                    {t('book_now')}
                  </MenuItem>
                  <MenuItem dense key={"Book Later"} value={"Book Later"} style={{direction:isRTL==='rtl'?'rtl':'ltr', width:'100%', justifyContent:'flex-start', paddingLeft:10,fontFamily:FONT_FAMILY}}>
                    {t('book_later')}
                  </MenuItem>
                </Select>
              </Grid>
              {bookingType === 'Book Later' ?
                <Grid item xs={12} sm={6} >
                  <TextField
                    InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                    id="datetime-local"
                    label={t('booking_date_time')}
                    type="datetime-local"
                    variant="outlined"
                    fullWidth
                    className={[isRTL==='rtl'?classes.inputRtl:classes.commonInputStyle, classes.textField].join(" ")}
                    InputProps={{
                      className: classes.input,
                      style:{textAlignLast:isRTL==='rtl'?'end':'start'}
                    }}
                    value={selectedDate}
                    onChange={onDateChange}
                  />
                </Grid>
              : null}
              {showPrimaryInfo ?
                <>
                  <Grid item xs={12}>
                    <Typography component="h3" variant="h6" style={{ marginTop: 8, color: colors.BLACK, fontFamily: FONT_FAMILY }}>
                      {label('primary_booking_information_form', 'Primary Booking Information Form')}
                    </Typography>
                  </Grid>
                  {availableServiceTypes.length > 1 ?
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth variant="outlined" className={isRTL==='rtl'?classes.inputRtl:classes.textField}>
                        <InputLabel id="serviceType-label" style={{ fontFamily: FONT_FAMILY }}>{label('serviceType')}</InputLabel>
                        <Select
                          labelId="serviceType-label"
                          id="serviceType"
                          name="serviceType"
                          value={normalizeServiceType(instructionData.serviceType)}
                          onChange={handleChange}
                          label={label('serviceType')}
                        >
                          {availableServiceTypes.map((option) => (
                            <MenuItem key={option} value={option}>{label(option)}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  : null}
                  {uniqueFields(showContainerInfo ? visibleContainerBookingTextFields : visibleGeneralCargoTextFields).map((field) => (
                    <Grid item xs={12} sm={6} key={field}>
                      <TextField
                        InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                        variant="outlined"
                        fullWidth
                        type={field === "itemDescription" ? "text" : "number"}
                        id={field}
                        label={label(field)}
                        name={field}
                        onChange={handleChange}
                        value={instructionData[field] || ""}
                        className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                        style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                      />
                    </Grid>
                  ))}
                  <Grid item xs={12}>
                    <Typography className={classes.typography} style={{ marginBottom: 8 }}>
                      {label('cargoDimensions', 'Cargo Dimensions (in cm)')}
                    </Typography>
                  </Grid>
                  {visibleCargoDimensionFields.map((field) => (
                    <Grid item xs={12} sm={4} key={field}>
                      <TextField
                        InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                        variant="outlined"
                        fullWidth
                        type="number"
                        id={field}
                        label={label(field)}
                        name={field}
                        onChange={handleChange}
                        value={instructionData[field] || ""}
                        className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                        style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                      />
                    </Grid>
                  ))}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                      variant="outlined"
                      fullWidth
                      id="note"
                      label={label('note')}
                      name="note"
                      multiline
                      minRows={2}
                      inputProps={{ maxLength: 70 }}
                      onChange={handleChange}
                      value={instructionData.note || ""}
                      className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                      style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                    />
                  </Grid>
                  {!showPickupDeliveryInfo ?
                    <Grid item xs={12} sm={6}>
                      <TextField
                        InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                        variant="outlined"
                        fullWidth
                        id="exactDeliveryAddress"
                        label={label('exactDeliveryAddress')}
                        name="exactDeliveryAddress"
                        onChange={handleChange}
                        value={instructionData.exactDeliveryAddress || ""}
                        className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                        style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                      />
                    </Grid>
                  : null}
                  {showPickupDeliveryInfo ?
                    <>
                      <Grid item xs={12}>
                        <Typography component="h3" variant="h6" style={{ marginTop: 8, color: colors.BLACK, fontFamily: FONT_FAMILY }}>
                          {label('pickup_delivery_information_form', 'Pickup & Delivery Information')}
                        </Typography>
                      </Grid>
                      {["pickupAddress", "deliveryAddress", "receiverName", "receiverContactNumber", "preferredPickupDate", "preferredPickupTime"].map((field) => (
                        <Grid item xs={12} sm={field === "pickupAddress" || field === "deliveryAddress" ? 12 : 6} key={field}>
                          <TextField
                            InputLabelProps={{ style: { fontFamily: FONT_FAMILY }, shrink: field === "preferredPickupDate" || field === "preferredPickupTime" }}
                            variant="outlined"
                            fullWidth
                            id={`pickupDelivery-${field}`}
                            label={label(field, field === "pickupAddress" ? "Pickup Address" : field === "deliveryAddress" ? "Delivery Address" : undefined)}
                            value={pickupDeliveryInfo[field] || ""}
                            type={field === "preferredPickupDate" ? "date" : field === "preferredPickupTime" ? "time" : "text"}
                            onChange={(event) => setPickupDeliveryInfoField(field, event.target.value)}
                            className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                            style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                          />
                        </Grid>
                      ))}
                    </>
                  : null}
                  {!showPickupDeliveryInfo && showShipmentTypeSelector ?
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth variant="outlined" className={isRTL==='rtl'?classes.inputRtl:classes.textField}>
                        <InputLabel id="shipmentType-label" style={{ fontFamily: FONT_FAMILY }}>{label('shipmentType')}</InputLabel>
                        <Select
                          labelId="shipmentType-label"
                          id="shipmentType"
                          name="shipmentType"
                          value={instructionData.shipmentType || ""}
                          onChange={handleChange}
                          label={label('shipmentType')}
                        >
                          {shipmentTypeOptions.map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  : null}
                  {!showPickupDeliveryInfo && showDomesticShipmentSelector ?
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth variant="outlined" className={isRTL==='rtl'?classes.inputRtl:classes.textField}>
                        <InputLabel id="shipmentType-domestic-label" style={{ fontFamily: FONT_FAMILY }}>{label('shipmentType')}</InputLabel>
                        <Select
                          labelId="shipmentType-domestic-label"
                          id="shipmentType"
                          name="shipmentType"
                          value={instructionData.shipmentType || ""}
                          onChange={handleChange}
                          label={label('shipmentType')}
                        >
                          <MenuItem value="Domestic Shipment">Domestic Shipment</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  : null}
                  {!showPickupDeliveryInfo && showDomesticInfo ?
                    <>
                      <Grid item xs={12}>
                        <Typography component="h3" variant="h6" style={{ marginTop: 8, color: colors.BLACK, fontFamily: FONT_FAMILY }}>
                          {label('domestic_booking_information_form', 'Domestic Booking Information Form')}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          InputLabelProps={{ style: { fontFamily: FONT_FAMILY }, shrink: true }}
                          variant="outlined"
                          fullWidth
                          type="date"
                          id="domesticBookingDate"
                          label={label('domesticBookingDate')}
                          value={domesticBookingInfo.bookingDate || ""}
                          onChange={(event) => setDomesticBookingInfoField("bookingDate", event.target.value)}
                          className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                          style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth variant="outlined" className={isRTL==='rtl'?classes.inputRtl:classes.textField}>
                          <InputLabel id="domesticShipmentType-label" style={{ fontFamily: FONT_FAMILY }}>{label('domesticShipmentType')}</InputLabel>
                          <Select
                            labelId="domesticShipmentType-label"
                            id="domesticShipmentType"
                            value={domesticBookingInfo.shipmentType || ""}
                            onChange={(event) => setDomesticBookingInfoField("shipmentType", event.target.value)}
                            label={label('domesticShipmentType')}
                          >
                            {domesticShipmentTypeOptions.map((option) => (
                              <MenuItem key={option} value={option}>{option}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      {domesticBookingTextFields.map((item) => (
                        <Grid item xs={12} sm={item.multiline ? 12 : 6} key={item.field}>
                          <TextField
                            InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                            variant="outlined"
                            fullWidth
                            id={`domestic-${item.field}`}
                            label={label(item.labelKey)}
                            value={domesticBookingInfo[item.field] || ""}
                            multiline={!!item.multiline}
                            minRows={item.multiline ? 2 : undefined}
                            onChange={(event) => setDomesticBookingInfoField(item.field, event.target.value)}
                            className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                            style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                          />
                        </Grid>
                      ))}
                    </>
                  : null}
                  {!showPickupDeliveryInfo && showImportInfo ?
                    <>
                      <Grid item xs={12}>
                        <Typography component="h3" variant="h6" style={{ marginTop: 8, color: colors.BLACK, fontFamily: FONT_FAMILY }}>
                          {label('import_booking_information_form', 'Import Booking Information Form')}
                        </Typography>
                      </Grid>
                      {importBookingTextFields.map((item) => (
                        <Grid item xs={12} sm={item.multiline ? 12 : 6} key={item.field}>
                          <TextField
                            InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                            variant="outlined"
                            fullWidth
                            id={`import-${item.field}`}
                            label={label(item.labelKey)}
                            value={importBookingInfo[item.field] || ""}
                            multiline={!!item.multiline}
                            minRows={item.multiline ? 2 : undefined}
                            onChange={(event) => setImportBookingInfoField(item.field, event.target.value)}
                            className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                            style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                          />
                        </Grid>
                      ))}
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth variant="outlined" className={isRTL==='rtl'?classes.inputRtl:classes.textField}>
                          <InputLabel id="import-containerType-label" style={{ fontFamily: FONT_FAMILY }}>{label('containerType')}</InputLabel>
                          <Select
                            labelId="import-containerType-label"
                            id="import-containerType"
                            value={importBookingInfo.containerType || ""}
                            onChange={(event) => setImportBookingInfoField("containerType", event.target.value)}
                            label={label('containerType')}
                          >
                            <MenuItem value=""><em>{label('select', 'Select')}</em></MenuItem>
                            {containerTypeOptions.map((option) => (
                              <MenuItem key={option} value={option}>{option}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth variant="outlined" className={isRTL==='rtl'?classes.inputRtl:classes.textField}>
                          <InputLabel id="import-containerSize-label" style={{ fontFamily: FONT_FAMILY }}>{label('containerSize')}</InputLabel>
                          <Select
                            labelId="import-containerSize-label"
                            id="import-containerSize"
                            value={selectedCarContainerSize || importBookingInfo.containerSize || ""}
                            disabled
                            label={label('containerSize')}
                          >
                            <MenuItem value={selectedCarContainerSize || importBookingInfo.containerSize || ""}>{selectedCarContainerSize || importBookingInfo.containerSize || ""}</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      {visibleLogisticsDateFields.map((field) => (
                        <Grid item xs={12} sm={6} key={`import-${field}`}>
                          <TextField
                            InputLabelProps={{ shrink: true, style: { fontFamily: FONT_FAMILY } }}
                            variant="outlined"
                            fullWidth
                            type="datetime-local"
                            id={`import-${field}`}
                            label={label(field)}
                            value={importBookingInfo[field] || ""}
                            onChange={(event) => setImportBookingInfoField(field, event.target.value)}
                            className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                            style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                          />
                        </Grid>
                      ))}
                      {visibleImportDetentionDateFields.map((field) => (
                        <Grid item xs={12} sm={6} key={`import-${field}`}>
                          <TextField
                            InputLabelProps={{ shrink: true, style: { fontFamily: FONT_FAMILY } }}
                            variant="outlined"
                            fullWidth
                            type="datetime-local"
                            id={`import-${field}`}
                            label={label(field)}
                            value={importBookingInfo[field] || ""}
                            onChange={(event) => setImportBookingInfoField(field, event.target.value)}
                            className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                            style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                          />
                        </Grid>
                      ))}
                      {visibleImportDetentionTextFields.map((item) => (
                        <Grid item xs={12} sm={item.multiline ? 12 : 6} key={`import-${item.field}`}>
                          <TextField
                            InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                            variant="outlined"
                            fullWidth
                            id={`import-${item.field}`}
                            label={label(item.labelKey)}
                            value={importBookingInfo[item.field] || ""}
                            multiline={!!item.multiline}
                            minRows={item.multiline ? 2 : undefined}
                            onChange={(event) => setImportBookingInfoField(item.field, event.target.value)}
                            className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                            style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                          />
                        </Grid>
                      ))}
                    </>
                  : null}
                  {!showPickupDeliveryInfo && showExportInfo ?
                    <>
                      <Grid item xs={12}>
                        <Typography component="h3" variant="h6" style={{ marginTop: 8, color: colors.BLACK, fontFamily: FONT_FAMILY }}>
                          {label('export_booking_information_form', 'Export Booking Information Form')}
                        </Typography>
                      </Grid>
                      {exportBookingTextFields.map((item) => (
                        <Grid item xs={12} sm={item.multiline ? 12 : 6} key={item.field}>
                          <TextField
                            InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                            variant="outlined"
                            fullWidth
                            id={`export-${item.field}`}
                            label={label(item.labelKey)}
                            value={exportBookingInfo[item.field] || ""}
                            multiline={!!item.multiline}
                            minRows={item.multiline ? 2 : undefined}
                            onChange={(event) => setExportBookingInfoField(item.field, event.target.value)}
                            className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                            style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                          />
                        </Grid>
                      ))}
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth variant="outlined" className={isRTL==='rtl'?classes.inputRtl:classes.textField}>
                          <InputLabel id="export-containerType-label" style={{ fontFamily: FONT_FAMILY }}>{label('containerType')}</InputLabel>
                          <Select
                            labelId="export-containerType-label"
                            id="export-containerType"
                            value={exportBookingInfo.containerType || ""}
                            onChange={(event) => setExportBookingInfoField("containerType", event.target.value)}
                            label={label('containerType')}
                          >
                            <MenuItem value=""><em>{label('select', 'Select')}</em></MenuItem>
                            {containerTypeOptions.map((option) => (
                              <MenuItem key={option} value={option}>{option}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth variant="outlined" className={isRTL==='rtl'?classes.inputRtl:classes.textField}>
                          <InputLabel id="export-containerSize-label" style={{ fontFamily: FONT_FAMILY }}>{label('containerSize')}</InputLabel>
                          <Select
                            labelId="export-containerSize-label"
                            id="export-containerSize"
                            value={selectedCarContainerSize || exportBookingInfo.containerSize || ""}
                            disabled
                            label={label('containerSize')}
                          >
                            <MenuItem value={selectedCarContainerSize || exportBookingInfo.containerSize || ""}>{selectedCarContainerSize || exportBookingInfo.containerSize || ""}</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      {exportDateFields.map((field) => (
                        <Grid item xs={12} sm={6} key={`export-${field}`}>
                          <TextField
                            InputLabelProps={{ shrink: true, style: { fontFamily: FONT_FAMILY } }}
                            variant="outlined"
                            fullWidth
                            type="datetime-local"
                            id={`export-${field}`}
                            label={label(field)}
                            value={exportBookingInfo[field] || ""}
                            onChange={(event) => setExportBookingInfoField(field, event.target.value)}
                            className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                            style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                          />
                        </Grid>
                      ))}
                    </>
                  : null}
                </>
              : null}
              {false && !showPickupDeliveryInfo && showContainerInfo && !showImportInfo && !showExportInfo ?
                <>
                  <Grid item xs={12}>
                    <Typography component="h3" variant="h6" style={{ marginTop: 8, color: colors.BLACK, fontFamily: FONT_FAMILY }}>
                      {label('container_shipping_info')}
                    </Typography>
                  </Grid>
                  {uniqueFields(visibleLogisticsTextFields).map((field) => (
                    <React.Fragment key={field}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                          variant="outlined"
                          fullWidth
                          id={field}
                          label={label(field)}
                          name={field}
                          onChange={handleChange}
                          value={instructionData[field] || ""}
                          className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                          style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                        />
                      </Grid>
                      {field === "containerNumber" ?
                        <>
                          {additionalContainerNumbers.map((value, index) => (
                            <Grid item xs={12} sm={6} key={`additional-container-number-${index}`}>
                              <TextField
                                InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                                variant="outlined"
                                fullWidth
                                id={`additionalContainerNumbers-${index}`}
                                label={`${label('additional_container_numbers')} ${index + 1}`}
                                value={value || ""}
                                onChange={(event) => updateAdditionalContainerNumber(index, event.target.value)}
                                className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                                style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                              />
                            </Grid>
                          ))}
                          <Grid item xs={12} sm={6}>
                            <Button
                              variant="outlined"
                              onClick={() => setInstructionData({ ...instructionData, additionalContainerNumbers: [...additionalContainerNumbers, ""] })}
                              style={{ width: "100%", minHeight: 56, fontFamily: FONT_FAMILY }}
                            >
                              {label('add_additional_container_number')}
                            </Button>
                          </Grid>
                        </>
                      : null}
                    </React.Fragment>
                  ))}
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth variant="outlined" className={isRTL==='rtl'?classes.inputRtl:classes.textField}>
                      <InputLabel id="containerType-label" style={{ fontFamily: FONT_FAMILY }}>{label('containerType')}</InputLabel>
                      <Select
                        labelId="containerType-label"
                        id="containerType"
                        name="containerType"
                        value={instructionData.containerType || ""}
                        onChange={handleChange}
                        label={label('containerType')}
                        style={{direction:isRTL==='rtl'?'rtl':'ltr', fontFamily: FONT_FAMILY}}
                      >
                        <MenuItem value=""><em>{t('select')}</em></MenuItem>
                        {containerTypeOptions.map((option) => (
                          <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth variant="outlined" className={isRTL==='rtl'?classes.inputRtl:classes.textField}>
                      <InputLabel id="containerSize-label" style={{ fontFamily: FONT_FAMILY }}>{label('containerSize')}</InputLabel>
                      <Select
                        labelId="containerSize-label"
                        id="containerSize"
                        name="containerSize"
                        value={instructionData.containerSize || ""}
                        onChange={handleChange}
                        disabled={!!selectedCarContainerSize}
                        label={label('containerSize')}
                        style={{direction:isRTL==='rtl'?'rtl':'ltr', fontFamily: FONT_FAMILY}}
                      >
                        <MenuItem value=""><em>{t('select')}</em></MenuItem>
                        <MenuItem value="10ft">10ft</MenuItem>
                        <MenuItem value="20ft">20ft</MenuItem>
                        <MenuItem value="40ft">40ft</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  {visibleLogisticsDateFields.map((field) => (
                    <Grid item xs={12} sm={6} key={field}>
                      <TextField
                        InputLabelProps={{ shrink: true, style: { fontFamily: FONT_FAMILY } }}
                        variant="outlined"
                        fullWidth
                        type="datetime-local"
                        id={field}
                        label={label(field)}
                        name={field}
                        onChange={handleChange}
                        value={instructionData[field] || ""}
                        className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                        style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                      />
                    </Grid>
                  ))}
                  <Grid item xs={12}>
                    <Typography className={classes.typography} style={{ marginBottom: 8 }}>
                      {label('date_confirmation_help')}
                    </Typography>
                    <Button
                      size="sm"
                      onClick={() => setInstructionData({ ...instructionData, dateConfirmationOk: true })}
                      className={instructionData.dateConfirmationOk ? classes.buttonStyle2 : classes.buttonStyle1}
                      style={{ width: 120, color: colors.WHITE }}
                    >
                      {instructionData.dateConfirmationOk ? label('date_confirmation_confirmed') : label('date_confirmation_ok_button')}
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <ContainerYardFilteredSelector
                      label={label('empty_return_container_yard')}
                      name="emptyReturnContainerYardIds"
                      value={instructionData.emptyReturnContainerYardIds || []}
                      onChange={handleChange}
                      containerYards={containerYards}
                      classes={classes}
                      isRTL={isRTL}
                      t={t}
                      multiple
                      disableUnavailable
                    />
                  </Grid>
                </>
              : null}
              {isFleetAdminUser ?
                <Grid item xs={12}>
                  <Box style={{ border: `1px solid ${colors.TABLE_BORDER || '#ddd'}`, borderRadius: 6, padding: 12, backgroundColor: colors.WHITE }}>
                    <Typography component="h3" variant="h6" style={{ marginBottom: 12, color: colors.BLACK, fontFamily: FONT_FAMILY }}>
                      {label('fleet_admin_private_client_booking', 'Fleet Admin Private Client Booking')}
                     </Typography>
                     <Grid container spacing={2}>
                       <Grid item xs={12}>
                         <UsersCombo
                           className={classes.items}
                           placeholder={label('select_saved_client', 'Select Saved Client')}
                           users={users || []}
                           value={userCombo}
                           onChange={handleFleetClientSelection}
                         />
                       </Grid>
                       <Grid item xs={12} sm={4}>
                        <TextField
                          InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                          variant="outlined"
                          fullWidth
                          id="clientName"
                          label={label('clientName', 'Client Name')}
                          name="clientName"
                          value={fleetClientBookingInfo.clientName}
                          onChange={handleFleetClientBookingInfoChange}
                          className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                          style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                        />
                       </Grid>
                       <Grid item xs={12} sm={8}>
                         <TextField
                           InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                           variant="outlined"
                           fullWidth
                           id="clientAddress"
                           label={label('clientAddress', 'Client Address')}
                           name="clientAddress"
                           value={fleetClientBookingInfo.clientAddress}
                           onChange={handleFleetClientBookingInfoChange}
                           className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                           style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                         />
                       </Grid>
                       <Grid item xs={12} sm={4} style={{ display: 'flex', alignItems: 'center' }}>
                         <Button
                           type="button"
                           color="primary"
                           disabled={savingFleetClient}
                           onClick={handleCreateFleetClient}
                         >
                           {savingFleetClient
                             ? label('saving_client', 'Saving Client...')
                             : label('save_new_client', 'Save New Client')}
                         </Button>
                       </Grid>
                       <Grid item xs={12} sm={4}>
                        <TextField
                          InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                          variant="outlined"
                          fullWidth
                          id="clientContact"
                          label={label('clientContact', 'Client Contact')}
                          name="clientContact"
                          value={fleetClientBookingInfo.clientContact}
                          onChange={handleFleetClientBookingInfoChange}
                          className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                          style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                          variant="outlined"
                          fullWidth
                          id="clientEmail"
                          label={label('clientEmail', 'Client Email')}
                          name="clientEmail"
                          value={fleetClientBookingInfo.clientEmail}
                          onChange={handleFleetClientBookingInfoChange}
                          className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                          style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                          variant="outlined"
                          fullWidth
                          type="number"
                          id="truckingChargeToClient"
                          label={label('truckingChargeToClient', 'Trucking Charge to Client')}
                          name="truckingChargeToClient"
                          value={fleetClientBookingInfo.truckingChargeToClient}
                          onChange={handleFleetClientBookingInfoChange}
                          inputProps={{ min: 0, step: "0.01" }}
                          className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                          style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                          variant="outlined"
                          fullWidth
                          id="superAdminCommissionType"
                          label={label('superAdminCommissionType', 'Super Admin Commission Type')}
                          value={fleetAdminFinancials.superAdminCommissionType}
                          InputProps={{ readOnly: true }}
                          className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                          style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                          variant="outlined"
                          fullWidth
                          id="superAdminCommissionValue"
                          label={label('superAdminCommissionValue', 'Super Admin Commission Value')}
                          value={fleetAdminFinancials.superAdminCommissionValue}
                          InputProps={{ readOnly: true }}
                          className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                          style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                          variant="outlined"
                          fullWidth
                          id="superAdminCommissionAmount"
                          label={label('superAdminCommissionAmount', 'Super Admin Commission Amount')}
                          value={formatCurrency(fleetAdminFinancials.superAdminCommissionAmount, settings)}
                          InputProps={{ readOnly: true }}
                          className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                          style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                          variant="outlined"
                          fullWidth
                          id="totalAdditionalFeeAmount"
                          label={label('totalAdditionalFeeAmount', 'Total Additional Fees')}
                          value={formatCurrency(fleetAdminFinancials.totalAdditionalFeeAmount, settings)}
                          InputProps={{ readOnly: true }}
                          className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                          style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
                          variant="outlined"
                          fullWidth
                          id="fleetAdminNetAmount"
                          label={label('fleetAdminNetAmount', 'Fleet Admin Net Amount')}
                          value={formatCurrency(fleetAdminFinancials.fleetAdminNetAmount, settings)}
                          InputProps={{ readOnly: true }}
                          className={isRTL==='rtl'?classes.inputRtl:classes.textField}
                          style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography className={classes.typography} style={{ fontWeight: 600, marginBottom: 8 }}>
                          {label('additionalFeesBreakdown', 'Additional Fees breakdown')}
                        </Typography>
                        {fleetAdminFinancials.additionalFees.length > 0 ?
                          fleetAdminFinancials.additionalFees.map((fee, index) => (
                            <Typography key={`${fee.name}-${index}`} className={classes.typography} style={{ color: colors.CARD_LABEL }}>
                              {fee.name || label('additionalFee', 'Additional Fee')} - {fee.rateType} {fee.value}: {formatCurrency(fee.amount, settings)}
                            </Typography>
                          ))
                        :
                          <Typography className={classes.typography} style={{ color: colors.CARD_LABEL }}>
                            {label('noAdditionalFees', 'No active additional fees')}
                          </Typography>
                        }
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              : null}
              {bookingType === 'Book Later' ?
                <Grid item xs={12} sm={6} >
                  <Button
                    size="lg"
                    onClick={handleGetOptions}
                    variant="contained" 
                    color="secondaryButton"
                    className={classes.buttonStyle}
                  >
                    <i className="fas fa-car" style={isRTL ==='rtl' ? {marginLeft:5}:{marginRight:5}}/>
                    {t('book')}
                  </Button>
                </Grid>
              :
                <Grid item xs={12} >
                  <Button
                    size="lg"
                    onClick={handleGetOptions}
                    variant="contained" 
                    color="secondaryButton"
                    className={classes.buttonStyle}
                  >
                    <i className="fas fa-car" style={isRTL ==='rtl' ? {marginLeft:5}:{marginRight:5}}/>
                    {t('book')}
                  </Button>
                </Grid>
              }
          </Grid>
        </div>
      </Grid>
      <Modal
        open={favoriteTranspoModalOpen}
        onClose={() => setFavoriteTranspoModalOpen(false)}
        className={classes.modal}
      >
        <Box className={classes.paper} style={{ maxHeight: '80vh', overflow: 'auto' }}>
          <Typography variant="h6" style={{ fontFamily: FONT_FAMILY, marginBottom: 12 }}>
            {label('favorite_transpo', 'Logistics Company')}
          </Typography>
          <TextField
            variant="outlined"
            fullWidth
            label={label('search_driver', 'Search Logistics Company')}
            value={favoriteTranspoSearch}
            onChange={(e) => setFavoriteTranspoSearch(e.target.value)}
            className={classes.textField}
            InputLabelProps={{ style: { fontFamily: FONT_FAMILY } }}
            InputProps={{ style: { fontFamily: FONT_FAMILY } }}
          />
          {favoriteTranspo ?
            <Button
              onClick={clearPreferredTranspo}
              color="secondaryButton"
              style={{ marginTop: 12, marginBottom: 8, width: '100%' }}
            >
              {label('clear_favorite_transpo', 'Clear Logistics Company')}
            </Button>
          : null}
          <List>
            {filteredFavoriteTranspos.length > 0 ? filteredFavoriteTranspos.map((company) => (
              <ListItemButton key={company.uid} onClick={() => setPreferredTranspo(company)}>
                <ListItemText
                  primary={getFavoriteTranspoName(company)}
                  secondary={getFavoriteTranspoType(company)}
                  primaryTypographyProps={{ style: { fontFamily: FONT_FAMILY } }}
                  secondaryTypographyProps={{ style: { fontFamily: FONT_FAMILY } }}
                />
              </ListItemButton>
            )) :
              <Typography style={{ fontFamily: FONT_FAMILY, marginTop: 16 }}>
                {label('no_logistics_company_found', 'No logistics company found')}
              </Typography>
            }
          </List>
        </Box>
      </Modal>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={optionModalStatus}
        onClose={handleOptionModalClose}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid container spacing={2} className={classes.paper}>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
          {selectedCarDetails && selectedCarDetails.parcelTypes?
            <FormControl component="fieldset">
              <FormLabel component="legend" style={{fontFamily:FONT_FAMILY,}}>{t('parcel_types')}</FormLabel>
              <RadioGroup name="parcelTypeIndex" value={instructionData.parcelTypeIndex} onChange={handleChange}>
                {selectedCarDetails.parcelTypes.map((element,index) =>
                  <FormControlLabel key={element.description} value={index} control={<Radio />} label={ <Typography className={classes.typography}>{formatCurrency(element.amount || 0, settings) + ' - ' + element.description}</Typography>}/>
                )}
              </RadioGroup>
            </FormControl>
          :null}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
          {selectedCarDetails && selectedCarDetails.options?
            <FormControl component="fieldset">
              <FormLabel component="legend" style={{fontFamily:FONT_FAMILY,}}>{t('options')}</FormLabel>
              <RadioGroup name="optionIndex" value={instructionData.optionIndex} onChange={handleChange}>
                {selectedCarDetails.options.map((element,index) =>
                  <FormControlLabel key={element.description} value={index} control={<Radio />} label={ <Typography className={classes.typography}>{formatCurrency(element.amount || 0, settings) + ' - ' + element.description}</Typography>} />
                )}
              </RadioGroup>
            </FormControl>
          :null}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}  style={{textAlign:isRTL==='rtl'?'right':'left'}}>
          <Button onClick={handleOptionModalClose} variant="contained" color="primary" className={classes.buttonStyle2}>
            {t('cancel')}
          </Button>
          <Button onClick={handleGetEstimate} variant="contained" color="primary" style={isRTL==='rtl'?{marginRight:10}:{marginLeft:10}} className={classes.buttonStyle1}>
            {t('get_estimate')}
          </Button>
          </Grid>
        </Grid>
      </Modal>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={estimateModalStatus}
        onClose={handleEstimateModalClose}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid container spacing={1} className={classes.paper}>
          <BookingModalBody 
              classes={classes}  
              instructionData={instructionData} 
              containerYards={containerYards}
              handleChange={handleChange}
              tripInstructions={tripInstructions}
              roundTrip={roundTrip}
              auth={auth}
              profileData={profileData}
              settings={settings}
              deliveryWithBid={deliveryWithBid}
              otherPerson={otherPerson}
              setOtherPerson={setOtherPerson}
              selectedCarDetails={selectedCarDetails}
              workflowConfigs={workflowconfigs.configs || []}
              hasAddedStops={hasAddedStops}
              minimumPrice={minimumPrice}
              offerFare={offerFare}
              estimate={estimatedata.estimate}
          />
          {auth.profile.usertype === 'customer'?
          <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
            <FormControl component="fieldset">
              <FormLabel component="legend" style={{fontFamily:FONT_FAMILY,}}>{t('payment_mode')}</FormLabel>
              <RadioGroup name="payment_mode" value={payment_mode} onChange={handleChange}>
                {radioProps.map((element,index) =>
                  <FormControlLabel key={element.cat} value={index} control={<Radio />} label={ <Typography className={classes.typography}>{element.label}</Typography>} />
                )}
              </RadioGroup>
            </FormControl>
          </Grid>
          :null}
          <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
          {loading?
            <DialogActions style={{justifyContent:'center', alignContent:'center'}}>
              <CircularProgress/>
            </DialogActions>
          :
            <Grid item xs={12} >
              <Button onClick={handleEstimateModalClose} variant="contained" style={{ backgroundColor:colors.RED, fontFamily:FONT_FAMILY }}>
                {t('cancel')}
              </Button>
              <Button onClick={confirmBooking} variant="contained"  style={isRTL==='rtl'?{marginRight:10, backgroundColor:colors.GREEN}:{marginLeft:10, backgroundColor:colors.GREEN, fontFamily:FONT_FAMILY}}>
                {t('book_now')}
              </Button>
            </Grid>
          }
          </Grid>
        </Grid>
      </Modal>

      <Modal
        disablePortal
        open={stopSwitchConfirm.open}
        onClose={() => setStopSwitchConfirm({ open: false, nextServiceType: "" })}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Box className={classes.paper}>
          <Typography component="h2" variant="h6" style={{ fontFamily: FONT_FAMILY, fontWeight: 700, marginBottom: 10 }}>
            {label('remove_added_stops', 'Remove Added Stops?')}
          </Typography>
          <Typography className={classes.typography} style={{ marginBottom: 18 }}>
            {label('remove_added_stops_message', 'Multiple stops are only available for Pickup & Delivery. Switching to Logistics Shipment will remove all added stops.')}
          </Typography>
          <Box style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
            <button
              type="button"
              onClick={() => setStopSwitchConfirm({ open: false, nextServiceType: "" })}
              style={{ minHeight: 40, padding: '0 14px', borderRadius: 4, border: `1px solid ${colors.TABLE_BORDER || '#ccc'}`, backgroundColor: colors.WHITE, cursor: 'pointer', fontFamily: FONT_FAMILY }}
            >
              {label('cancel', 'Cancel')}
            </button>
            <button
              type="button"
              onClick={continueServiceSwitchAfterClearingStops}
              style={{ minHeight: 40, padding: '0 14px', borderRadius: 4, border: 'none', backgroundColor: MAIN_COLOR, color: colors.WHITE, cursor: 'pointer', fontFamily: FONT_FAMILY }}
            >
              {label('continue_remove_stops', 'Continue and Remove Stops')}
            </button>
          </Box>
        </Box>
      </Modal>

      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={walletModalStatus}
        onClose={handleWalletModalClose}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid container spacing={2} className={classes.paper}>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{marginBottom: '20px'}}>
            <Typography  style={{fontWeight:'bolder', marginBottom:10}}>
              {t('payment')}
            </Typography>
            {bookingdata && bookingdata.booking?
            <Typography color={"primary"} style={{fontSize:30}}>
              {formatCurrency(bookingdata.booking.mainData.trip_cost, settings)}
            </Typography>
            :null}
            <Typography >
              {t('use_wallet_balance') + " " + formatCurrency(auth.profile.walletBalance, settings) + ")"}
            </Typography>
          </Grid>            
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Button onClick={handleWalletModalClose} variant="contained" style={{backgroundColor:colors.RED }}>
              {t('cancel')}
            </Button>
            <Button variant="contained" color="primary" style={{marginLeft:10,backgroundColor:colors.GREEN}} onClick={handleWalletPayment}>
              {t('paynow_button')}
            </Button>
          </Grid>
        </Grid>
      </Modal>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={paymentModalStatus}
        onClose={handlePaymentModalClose}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid container spacing={2} className={classes.paper}>
          {providers && selectedProvider && bookingdata && bookingdata.booking?
          <form action={selectedProvider.link} method="POST">
            <input type='hidden' name='order_id' value={bookingdata.booking.booking_id}/>
            <input type='hidden' name='amount' value={bookingdata.booking.mainData.trip_cost}/>
            <input type='hidden' name='currency' value={settings.code}/>
            <input type='hidden' name='product_name' value={t('bookingPayment')}/>
            <input type='hidden' name='first_name' value={auth.profile.firstName}/>
            <input type='hidden' name='last_name' value={auth.profile.lastName}/>
            <input type='hidden' name='quantity' value={1}/>
            <input type='hidden' name='cust_id' value={bookingdata.booking.mainData.customer}/>
            <input type='hidden' name='mobile_no' value={bookingdata.booking.mainData.customer_contact}/>
            <input type='hidden' name='email' value={bookingdata.booking.mainData.customer_email}/>
            <input type='hidden' name='payment_method' value={selectedProvider.method || selectedProvider.name}/>
            <Grid item xs={12} sm={12} md={12} lg={12} style={{marginBottom: '20px'}}>
              <FormControl fullWidth>
              <FormLabel component="legend">{t('payment')}</FormLabel>
              <Select
                  id="selectedProviderIndex"
                  name= "selectedProviderIndex"
                  value={selectedProviderIndex}
                  label={t('payment')}
                  onChange={handleChange}
                  style={{textAlign:isRTL==='rtl'? 'right':'left'}}
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  {providers.map((provider,index) =>
                    <MenuItem key={provider.name} value={index}>
                      <img style={{height:24,margin:7}} src={icons[provider.name]} alt={provider.name}/>
                      {paymentProviderLabel(provider)}
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
            <Button onClick={handlePaymentModalClose} variant="contained" color="primary">
              {t('cancel')}
            </Button>
            <Button variant="contained" color="primary" type="submit" style={{marginLeft:10}} onClick={handlePaymentModalClose}>
              {t('paynow_button')}
            </Button>
            </Grid>
          </form>
          :null}
        </Grid>
      </Modal>
      <AlertDialog open={bookingdata.error.flag} onClose={handleBookingErrorClose}>{bookingdata.error.msg}</AlertDialog>
      <AlertDialog open={estimatedata.error.flag} onClose={handleEstimateErrorClose}>{estimatedata.error.msg}</AlertDialog>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
    </div>
  );
}
